import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ReactFlowProvider, Node, Edge, getOutgoers } from 'reactflow';
import Flow, { NodeItem } from './../FlowRenderer/react-flow';
import Box from '@mui/material/Box';
import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  lighten,
  useTheme,
} from '@mui/material';
// import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded';
import Modal from '../../common/Modal';
import FormModal from '../../common/formModal';
import DataTable from '../../components/DataTable';
import PopUp from '../../components/Popup';
import { ReactComponent as SuccessIcon } from '../../assets/icons/main/successIcon.svg';
import { parseExcelImport } from '../../utils/parseExcelImport';
import FlowImportValidationModal from '../FlowImportValidationModal';
import FlowImportDuplicateModal from '../../common/FlowImportDuplicateModal';
import FlowImportScanModal from '../../common/FlowImportScanModal';
import FlowImportMessageValidationModal from '../FlowImportMessageValidationModal';
import ImportAssetsModal from '../importAssetsModal';

import Chip from '@mui/material/Chip';
import { connect, useDispatch } from 'react-redux';
import { matchRoutes, useLocation, useParams, useOutletContext } from 'react-router-dom';
import { buildUseCaseActions } from '../../store/reducers/build-usecases';
import { gatewayMasterActions } from '../../store/reducers/gateway-master';
import { machineryManagementActions } from '../../store/reducers/machinery-management';
import { componentMasterActions } from '../../store/reducers/component-master';
import { ReactComponent as SaveIcon } from '../../assets/icons/main/save-icon.svg';
import { paramCase } from 'change-case';
import { forEach, get, has, uniqBy } from 'lodash';
import { platformServicesMasterActions } from '../../store/reducers/platform-master';
import { servicesActions } from '../../store/reducers/services';
import { factoryManagementActions } from '../../store/reducers/factory-management';
import FactoryManagementService from '../../store/api/factoryManagementService';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
import { secretManagerActions } from '../../store/reducers/secret-manager';
import Snackbar from '../snackBar';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { useAuth } from 'react-oidc-context';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as VerticalLineIcon } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as RestoreIcon } from '../../assets/icons/main/restore-icon.svg';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as ExcelIcon } from '../../assets/icons/main/microsoft-excel-icon.svg';
import { palette } from '../../theme/palette';
// import { routePaths } from '../../utils/route-paths';

const Styles = {
  container: {
    height: 'auto',
    minHeight: '600px',
    // backgroundColor: '#fff',
    boxShadow: '0px 0px 14px 0px #0000000D',
    borderRadius: '18px',
    marginBottom: 1,
  },
  header: {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    overflow: 'hidden',
    borderRadius: '16px 16px 0px 0px',
  },
  flowWrapper: {
    // height: '750px',
    minHeight: '600px',
    height: 'calc(100vh - 260px)',
    boxSizing: 'border-box',
    overflowY: 'hidden',
    overflowX: 'auto',
    borderRadius: '0 0 16px 16px',
  },
  titleWrapper: {
    display: 'flex',
  },
  // footer: {
  //   textAlign: 'center',
  //   color: '#64759F',
  //   marginBottom: '32px',
  // },
  spinnerWrapper: {
    height: 'calc(100vh - 325px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const addModalStyles = {
  container: {
    width: '99%',
    // height: '400px',
    boxShadow: '0px 0px 14px 0px #0000000D',
    padding: '24px',
    boxSizing: 'border-box',
    marginBlock: '4px',
    borderRadius: '18px',
  },
  header: {
    height: '64px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
  tableWrapper: {
    // height: '220px',
    // border: '1px solid red',
    // overflow: 'auto',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '24px',
  },
  checkBox: {
    '& .MuiSvgIcon-root': { color: '#5C85FF !important', fontSize: '1.5rem !important' },
  },
  chip: {
    backgroundColor: '#eef3ff',
  },
};

interface FlowRendererPropTypes {
  isFactoryLoading: boolean;
  isUseCaseDataLoading: boolean;
  isGatewayMasterDataLoading: boolean;
  isComponentMasterDataLoading: boolean;
  isMachineryManagementDataLoading: boolean;
  isUseCasesListLoading: boolean;
  isUpdateUseCaseSuccess: boolean;
  services: any;
  selectedRow: any;
  gateways: any;
  components: any;
  machines: any;
  rowTitle: string;
  rowId: string;
  readonly?: boolean;
  factoriesList: any[];
  onDataRequest: () => void;
  useCase?: boolean;
  isSelectedRowLoading: boolean;
  userAccess: any;
  factoryLabel?: string;
  assetComponents: any;
  isUpdateFactorySuccess: boolean;
  oldNodes: any[];
  secretsData: any[];
}

const normalizeUiConfig = (uiConfig: any): { nodes: Node[]; edges: Edge[];[key: string]: any } => {
  const sanitizeUiConfigObject = (value: any) => {
    const source = value && typeof value === 'object' ? value : {};
    const cleaned = Object.fromEntries(
      Object.entries(source).filter(([key]) => !/^\d+$/.test(String(key)))
    );

    return {
      ...cleaned,
      nodes: Array.isArray((cleaned as any).nodes) ? (cleaned as any).nodes : [],
      edges: Array.isArray((cleaned as any).edges) ? (cleaned as any).edges : [],
    };
  };

  if (!uiConfig) return { nodes: [], edges: [] };

  if (typeof uiConfig === 'string') {
    try {
      const parsed = JSON.parse(uiConfig);
      if (parsed && typeof parsed === 'object') {
        return sanitizeUiConfigObject(parsed);
      }
    } catch {
      return { nodes: [], edges: [] };
    }
    return { nodes: [], edges: [] };
  }

  if (typeof uiConfig === 'object') {
    return sanitizeUiConfigObject(uiConfig);
  }

  return { nodes: [], edges: [] };
};

const getNodePayload = (node: any, nodes: Node[]) => {
  const nodeOperation = node.operation ? { operation: node.operation } : {};
  const resolvedConnectedTo = get(node, 'connectedTo', get(node, 'data.connectedTo'));
  switch (node.type) {
    case 'cloudNode':
      return {
        id: 'cloud',
        type: 'cloudNode',
        ...nodeOperation,
        data: {
          id: 'cloud',
          type: 'cloudNode',
        },
      };
    case 'edgeNode':
      return {
        id: node.id,
        type: 'edgeNode',
        ...nodeOperation,
        data: {
          id: node.id,
          type: 'edgeNode',
          connectedTo: resolvedConnectedTo,
          gateway_id: get(node, 'data.gateway_id'),
          ip: get(node, 'data.cidr_to_scan'),
        },
      };
    case 'assetNode':
      const gatewayId = nodes.find((n) => n.id === resolvedConnectedTo)?.data?.gateway_id;
      return {
        id: node.id,
        ...nodeOperation,
        type: 'assetNode',
        connectedTo: resolvedConnectedTo,
        data: {
          type: 'assetNode',
          connectedTo: resolvedConnectedTo,
          gateway_id: gatewayId,
          id: node.id,
          ip: get(node, 'data.ip'),
          name: get(node, 'data.name'),
          enabled: get(node, 'data.enabled'),
          data: {
            options: get(node, 'data.options', []),
          },
        },
      };
    case 'machineNode':
      return {
        id: node.id,
        type: 'machineNode',
        ...nodeOperation,
        connectedTo: resolvedConnectedTo,
        data: {
          type: 'machineNode',
          connectedTo: resolvedConnectedTo,
          id: node.id,
          machine_id: get(node, 'data.machine_id'),
        },
      };
    default:
      return node;
  }
};

const getRemovedNodePayload = (node: any, nodes: Node[]) => {
  const resolvedConnectedTo = get(node, 'connectedTo', get(node, 'data.connectedTo'));
  switch (node.type) {
    case 'cloudNode':
      return {
        id: 'cloud',
        type: 'cloudNode',
        operation: 'deleted',
        data: {
          id: 'cloud',
          type: 'cloudNode',
          operation: 'deleted',
        },
      };
    case 'edgeNode':
      return {
        id: node.id,
        type: 'edgeNode',
        operation: 'deleted',
        data: {
          id: node.id,
          type: 'edgeNode',
          connectedTo: resolvedConnectedTo,
          gateway_id: get(node, 'gateway_id'),
          ip: get(node, 'cidr_to_scan'),
        }
      };
    case 'assetNode':
      const gatewayId = get(nodes.find((n) => n.id === resolvedConnectedTo), 'gateway_id');
      return {
        type: 'assetNode',
        operation: 'deleted',
        id: node.id,
        connectedTo: resolvedConnectedTo,
        data: {
          type: 'assetNode',
          connectedTo: resolvedConnectedTo,
          gateway_id: gatewayId,
          id: node.id,
          ip: get(node, 'ip'),
          name: get(node, 'name'),
          enabled: get(node, 'enabled'),
          data: {
            options: get(node, 'options', []),
          },
        },
      };
    case 'machineNode':
      return {
        type: 'machineNode',
        id: node.id,
        operation: 'deleted',
        connectedTo: resolvedConnectedTo,
        data: {
          type: 'machineNode',
          connectedTo: resolvedConnectedTo,
          id: node.id,
          machine_id: get(node, 'machine_id'),
        },
      };
    default:
      return node;
  }
};

const FlowRenderer = ({
  isFactoryLoading,
  isUseCaseDataLoading,
  isGatewayMasterDataLoading,
  isComponentMasterDataLoading,
  isUseCasesListLoading,
  isUpdateUseCaseSuccess,
  isMachineryManagementDataLoading,
  selectedRow,
  gateways,
  components,
  machines,
  services,
  rowTitle,
  readonly = false,
  rowId,
  factoriesList,
  useCase = false,
  onDataRequest = () => { },
  isSelectedRowLoading,
  userAccess,
  factoryLabel = 'Factory',
  assetComponents,
  isUpdateFactorySuccess,
  oldNodes,
  secretsData,
}: FlowRendererPropTypes) => {
  const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);
  const [emptyAssetsPopup, setEmptyAssetsPopup] = useState(false);

  // Excel import state
  const [importGatewayModal, setImportGatewayModal] = useState<{
    open: boolean;
    selectedGatewayId: string | null;
    locked?: boolean;
  }>({ open: false, selectedGatewayId: null, locked: false });
  const [pendingImportFile, setPendingImportFile] = useState<File | null>(null);
  const [importPreview, setImportPreview] = useState<{
    open: boolean;
    json: string;
    assets: any[];
    errors: string[];
    selectedGatewayId: string | null;
    selectedGatewayData?: any;
    validationRows: any[];
    validationErrors: string[];
    validationWarnings: string[];
  }>({
    open: false,
    json: '',
    assets: [],
    errors: [],
    selectedGatewayId: null,
    selectedGatewayData: null,
    validationRows: [],
    validationErrors: [],
    validationWarnings: [],
  });
  const [importScanModal, setImportScanModal] = useState<{
    open: boolean;
    assets: any[];
    scanAssetIndexes: number[];
    selectedGatewayId: string | null;
    selectedGatewayData?: any;
  }>({
    open: false,
    assets: [],
    scanAssetIndexes: [],
    selectedGatewayId: null,
    selectedGatewayData: null,
  });
  const [importMessageValidationModal, setImportMessageValidationModal] = useState<{
    open: boolean;
    assets: any[];
    failedAssetIndexes: number[];
    selectedGatewayId: string | null;
    selectedGatewayData?: any;
  }>({
    open: false,
    assets: [],
    failedAssetIndexes: [],
    selectedGatewayId: null,
    selectedGatewayData: null,
  });
  const [importDuplicateModal, setImportDuplicateModal] = useState<{
    open: boolean;
    strategy: 'overwrite' | 'skip' | 'merge' | null;
    candidateAssets: any[];
    totalCandidateAssets: number;
    duplicatePairs: Array<{
      importedIndex: number;
      existingNodeId: string;
      importedAsset: any;
      existingAsset: any;
      componentOverlaps: string[];
    }>;
    selectedGatewayId: string | null;
    selectedGatewayData?: any;
  }>({
    open: false,
    strategy: null,
    candidateAssets: [],
    totalCandidateAssets: 0,
    duplicatePairs: [],
    selectedGatewayId: null,
    selectedGatewayData: null,
  });
  const [queuedImportDuplicateModal, setQueuedImportDuplicateModal] = useState<null | {
    strategy: 'overwrite' | 'skip' | 'merge' | null;
    candidateAssets: any[];
    totalCandidateAssets: number;
    duplicatePairs: Array<{
      importedIndex: number;
      existingNodeId: string;
      importedAsset: any;
      existingAsset: any;
      componentOverlaps: string[];
    }>;
    selectedGatewayId: string | null;
    selectedGatewayData?: any;
  }>(null);
  const [isImporting, setIsImporting] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [isPreparingData, setIsPreparingData] = useState(false);
  const [pendingDuplicateAssetIds, setPendingDuplicateAssetIds] = useState<string[]>([]);
  const [isWaitingDuplicateBatch, setIsWaitingDuplicateBatch] = useState(false);
  const [pendingModifiedScanAssetIds, setPendingModifiedScanAssetIds] = useState<string[]>([]);
  const [queuedModifiedScanRequest, setQueuedModifiedScanRequest] = useState<null | {
    candidateAssets: any[];
    selectedGatewayId: string;
    selectedGatewayData?: any;
  }>(null);
  const [isWaitingModifiedScanBatch, setIsWaitingModifiedScanBatch] = useState(false);
  const provisionedGateways = gateways.filter((gateway: any) => gateway.data_transfer_status === 'provisioned');

  type ImportScanWaiter = {
    expectedGatewayId: string;
    started: boolean;
    onStarted?: () => void;
    resolve: (result: {
      status: 'completed';
      started: boolean;
      topic?: string;
      message?: any;
    }) => void;
  };

  const importScanCommandWaitersRef = useRef<Map<string, ImportScanWaiter>>(new Map());

  const normalizeScanLifecycleText = (value: any) => {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase().replace(/[\s-]+/g, '_');
  };

  const parseScanCommandResult = (value: any) => {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!trimmed) return value;
    if (
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    ) {
      try {
        return JSON.parse(trimmed);
      } catch {
        return value;
      }
    }
    return value;
  };

  const getImportScanCommandField = (message: any, field: string) => {
    const lookupPaths = [
      field,
      `payload.${field}`,
      `params.${field}`,
      `data.${field}`,
      `message.${field}`,
      `telemetryMessage.${field}`,
      `result.${field}`,
      `payload.result.${field}`,
    ];

    for (const path of lookupPaths) {
      const value = get(message, path);
      if (value !== undefined) return value;
    }

    return undefined;
  };

  const getScanLifecycleText = (result: any) => {
    const candidates = [
      result,
      get(result, 'status'),
      get(result, 'state'),
      get(result, 'result'),
      get(result, 'message'),
    ];

    for (const candidate of candidates) {
      const normalized = normalizeScanLifecycleText(candidate);
      if (normalized) return normalized;
    }

    return '';
  };

  const SCAN_FAILURE_LIFECYCLE = new Set([
    'failed',
    'error',
    'scan_failed',
    'scan_error',
    'stopped',
    'scan_stopped',
    'cancelled',
    'canceled',
    'aborted',
    'timeout',
    'timed_out',
    'connection_error',
    'data_error',
  ]);

  const hasImportScanFailureSignal = (result: any): boolean => {
    const candidates = [
      result,
      get(result, 'status'),
      get(result, 'state'),
      get(result, 'result'),
      get(result, 'message'),
      get(result, 'scan_status'),
      get(result, 'scanState'),
      get(result, 'outcome'),
      get(result, 'error'),
      get(result, 'scan.error'),
    ];

    return candidates.some((candidate) => {
      const normalized = getScanLifecycleText(candidate);
      return normalized ? SCAN_FAILURE_LIFECYCLE.has(normalized) : false;
    });
  };

  const NON_TERMINAL_IMPORT_SCAN_RESULTS = new Set([
    'scan_command_received',
    'command_received',
    'accepted',
    'queued',
    'processing',
    'in_progress',
    'scan_started',
    'scanning_started',
    'started',
  ]);

  const cancelImportScanCommandWaiter = useCallback((commandId: string) => {
    const waiter = importScanCommandWaitersRef.current.get(commandId);
    if (!waiter) return;

    importScanCommandWaitersRef.current.delete(commandId);
    waiter.resolve({
      status: 'completed',
      started: waiter.started,
      message: {
        command_id: commandId,
        result: 'stopped',
        error: 'cancelled',
      },
    });
  }, []);

  const resolveImportScanCommandResponse = useCallback((payload: any) => {
    const topic = String(payload?.topic || '');

    // Support all payload shapes:
    // 1) { topic, message: {...} }
    // 2) { topic, message: { telemetryMessage: {...} } }
    // 3) { topic, telemetryMessage: {...} }
    // 4) direct message object
    const envelope = payload?.message ?? payload;
    const message =
      envelope?.telemetryMessage ??
      envelope?.message ??
      payload?.telemetryMessage ??
      envelope;

    const commandId = String(getImportScanCommandField(message, 'command_id') ?? '').trim();
    if (!commandId) return;

    const waiter = importScanCommandWaitersRef.current.get(commandId);
    if (!waiter) return;

    const [, gatewayIdFromTopic = '', , messageType = ''] = topic.split('/');

    if (gatewayIdFromTopic && String(waiter.expectedGatewayId) !== String(gatewayIdFromTopic)) return;

    const errorRaw = String(getImportScanCommandField(message, 'error') ?? '').trim();
    const errorNormalized = errorRaw.toLowerCase();
    const errorMessage = ['', 'none', 'null', 'nil', 'no error', 'ok', 'success'].includes(errorNormalized)
      ? ''
      : errorRaw;

    if (errorMessage) {
      importScanCommandWaitersRef.current.delete(commandId);
      waiter.resolve({ status: 'completed', started: waiter.started, topic, message });
      return;
    }

    const parsedResult = parseScanCommandResult(getImportScanCommandField(message, 'result'));
    const lifecycleText = getScanLifecycleText(parsedResult);

    // Non-terminal scan lifecycle events should not resolve the waiter.
    if (NON_TERMINAL_IMPORT_SCAN_RESULTS.has(lifecycleText)) {
      if (!waiter.started) {
        waiter.started = true;
        waiter.onStarted?.();
      }
      return;
    }

    if (messageType === 'commands') {
      // keep backward compatibility
      return;
    }

    if (messageType === 'command_response' || !messageType) {
      importScanCommandWaitersRef.current.delete(commandId);
      waiter.resolve({ status: 'completed', started: waiter.started, topic, message });
    }
  }, []);

  const waitForImportScanCommandResponse = useCallback(
    (commandId: string, gatewayId: string, onStarted?: () => void) => {
      return new Promise<{
        status: 'completed';
        started: boolean;
        topic?: string;
        message?: any;
      }>((resolve) => {
        importScanCommandWaitersRef.current.set(commandId, {
          expectedGatewayId: String(gatewayId),
          started: false,
          onStarted,
          resolve,
        });
      });
    },
    []
  );

  useEffect(() => {
    return () => {
      importScanCommandWaitersRef.current.clear();
    };
  }, []);

  const resolveGatewayIdForImport = (rawGatewayId: any, gatewayData?: any): string | null => {
    const asString = String(rawGatewayId ?? '').trim();
    const fromData = String(get(gatewayData, 'gateway_id', '')).trim();

    const knownIds = new Set(
      (gateways || []).map((gw: any) => String(gw.gateway_id ?? '').trim()).filter(Boolean)
    );

    if (asString && knownIds.has(asString)) return asString;
    if (fromData && knownIds.has(fromData)) return fromData;

    // Allow direct ids from node data even when gateway list is stale.
    if (fromData) return fromData;
    if (asString && !asString.toLowerCase().startsWith('edge-')) return asString;

    // Node id can come as edge-<gatewayId> from graph interactions.
    if (asString.toLowerCase().startsWith('edge-')) {
      const stripped = asString.slice(5).trim();
      if (stripped && (knownIds.has(stripped) || stripped)) return stripped;
    }

    return null;
  };

  const getGatewayScopedAssetNodes = (nodes: any[], selectedGatewayId: string) => {
    const selectedGatewayNode = nodes.find(
      (n: any) => n.type === 'edgeNode' && String(get(n, 'data.gateway_id')) === String(selectedGatewayId)
    );

    return nodes.filter((n: any) => {
      if (n.type !== 'assetNode') return false;
      const byConnectedTo =
        selectedGatewayNode &&
        String(get(n, 'connectedTo', get(n, 'data.connectedTo', ''))) ===
        String(get(selectedGatewayNode, 'id', ''));
      const byGatewayId = String(get(n, 'data.gateway_id', '')) === String(selectedGatewayId);
      return Boolean(byConnectedTo || byGatewayId);
    });
  };

  const isNodeMarkedDeleted = (node: any) =>
    normalizeText(get(node, 'operation', '')) === 'deleted' ||
    normalizeText(get(node, 'data.operation', '')) === 'deleted';

  const getLocallyEffectiveNodes = (nodes: any[]) => {
    const activeNodeIds = new Set(
      (nodes || [])
        .filter((node: any) => !isNodeMarkedDeleted(node))
        .map((node: any) => String(get(node, 'id', '')))
        .filter(Boolean)
    );

    const shouldKeepRemovedId = (id: any) => {
      const normalizedId = String(id ?? '').trim();
      if (!normalizedId) return false;
      // If a node with same id exists locally and is active, treat it as restored/re-added.
      return !activeNodeIds.has(normalizedId);
    };

    const directRemovedIds = new Set([
      ...(removedNodes || []).map((node: any) => String(node.id)).filter(shouldKeepRemovedId),
      ...(importedRemovedNodesRef.current || []).map((node: any) => String(node.id)).filter(shouldKeepRemovedId),
      ...(nodes || []).filter((node: any) => isNodeMarkedDeleted(node)).map((node: any) => String(node.id)),
    ]);

    // Cascade removals to descendants linked via connectedTo (edge -> asset/machine etc.)
    const cascadedRemovedIds = new Set(Array.from(directRemovedIds));
    let changed = true;
    while (changed) {
      changed = false;
      (nodes || []).forEach((node: any) => {
        const nodeId = String(get(node, 'id', ''));
        const parentId = String(get(node, 'connectedTo', get(node, 'data.connectedTo', '')));
        if (!nodeId || cascadedRemovedIds.has(nodeId)) return;
        if (parentId && cascadedRemovedIds.has(parentId)) {
          cascadedRemovedIds.add(nodeId);
          changed = true;
        }
      });
    }

    return (nodes || []).filter((node: any) => !cascadedRemovedIds.has(String(node.id)));
  };

  const getEffectiveConfigNodes = () => {
    return getLocallyEffectiveNodes(config?.nodes ?? []);
  };

  const extractScannedTagKeys = (scanResult: any): Set<string> => {
    const keys = new Set<string>();
    if (!Array.isArray(scanResult)) return keys;

    scanResult.forEach((item: any) => {
      if (item === null || item === undefined) return;

      if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
        const token = String(item).trim().toLowerCase();
        if (token) keys.add(token);
        return;
      }

      if (typeof item !== 'object') return;

      [
        get(item, 'name'),
        get(item, 'Name'),
        get(item, 'tag'),
        get(item, 'key'),
        get(item, 'id'),
        get(item, 'nodeId'),
        get(item, 'address'),
        get(item, 'displayName'),
      ].forEach((candidate) => {
        const token = String(candidate ?? '').trim().toLowerCase();
        if (token) keys.add(token);
      });
    });

    return keys;
  };

  const normalizeText = (value: any) => String(value ?? '').trim().toLowerCase();

  const readAssetIdentity = (asset: any) => ({
    name: normalizeText(get(asset, 'data.name', get(asset, 'name', ''))),
    ip: normalizeText(get(asset, 'data.ip', get(asset, 'ip', ''))),
  });

  const hasAssetIdentity = (asset: any) => {
    const { name } = readAssetIdentity(asset);
    return name !== '';
  };

  const isDuplicateAssetIdentity = (a: any, b: any) => {
    if (!hasAssetIdentity(a)) return false;
    const aIdentity = readAssetIdentity(a);
    const bIdentity = readAssetIdentity(b);
    return aIdentity.name === bIdentity.name;
  };

  const ASSET_LEVEL_DUPLICATE_COMPONENT_KEY = '__asset_level_duplicate__';
  const getNormalizedComponentName = (option: any) =>
    String(get(option, 'component_name', get(option, 'label', ''))).trim().toLowerCase();

  const findImportDuplicatePairs = async (assets: any[], selectedGatewayId: string): Promise<Array<{
    importedIndex: number;
    existingNodeId: string;
    importedAsset: any;
    existingAsset: any;
    componentOverlaps: string[];
  }>> => {
    const effectiveNodes = getEffectiveConfigNodes();
    const resolvedGatewayId = resolveGatewayIdForImport(selectedGatewayId);
    const normalizedGatewayId = String(resolvedGatewayId ?? selectedGatewayId ?? '').trim();

    let existingAssets = getGatewayScopedAssetNodes(effectiveNodes, normalizedGatewayId);

    // Fallback: when selected gateway id comes as edge node id or gateway scoping cannot resolve,
    // still scope by edge connection to avoid missing duplicate popup.
    if (existingAssets.length === 0) {
      const edgeNodeId = normalizedGatewayId.toLowerCase().startsWith('edge-')
        ? normalizedGatewayId
        : `edge-${normalizedGatewayId}`;

      existingAssets = effectiveNodes.filter((n: any) => {
        if (n.type !== 'assetNode') return false;
        return String(get(n, 'connectedTo', get(n, 'data.connectedTo', ''))) === edgeNodeId;
      });
    }

    // For existing assets, we'll fetch component details on accordion expand in the modal.
    // For now, just include the node with whatever options are already available (from sidebar or store).
    const enrichedExistingAssets = existingAssets.map((node: any) => {
      // If options are already populated (via sidebar click), keep them.
      // Otherwise, leave as empty and fetch on modal expand.
      return node;
    });

    const results = await Promise.all(
      assets.map(async (asset: any, importedIndex: number) => {
        const existing = enrichedExistingAssets.find((node: any) => {
          return isDuplicateAssetIdentity(asset, node);
        });

        if (!existing) return null;

        const existingOptionsFromSidebar = get(existing, 'data.options', []) as any[];
        const existingComponentsFromApi = get(existing, 'components', []) as any[];
        const existingComponentNames = new Set(
          [...existingOptionsFromSidebar, ...existingComponentsFromApi]
            .map((opt: any) => getNormalizedComponentName(opt))
            .filter(Boolean)
        );
        const importedComponentNames = new Set(
          (get(asset, 'data.options', []) as any[])
            .map((opt: any) => getNormalizedComponentName(opt))
            .filter(Boolean)
        );
        const componentOverlaps = Array.from(importedComponentNames).filter((name) => existingComponentNames.has(name));

        return {
          importedIndex,
          existingNodeId: String(existing.id),
          importedAsset: asset,
          existingAsset: existing,
          componentOverlaps,
        };
      })
    );

    return results.filter(Boolean) as Array<{
      importedIndex: number;
      existingNodeId: string;
      importedAsset: any;
      existingAsset: any;
      componentOverlaps: string[];
    }>;
  };
  const getLocalAssetOptions = (assetId: string) => {
    const node = (config?.nodes || []).find((n: any) => String(n.id) === String(assetId));
    const options = get(node, 'data.options', []);
    return Array.isArray(options) ? options : [];
  };
  const getEffectiveExistingOptions = (assetId: string, fallback: any[] = []) => {
    const apiOptions = get(assetComponents, `${assetId}.components`, []);
    const localOptions = getLocalAssetOptions(assetId);

    const byName = new Map<string, any>();
    const put = (opt: any) => {
      const key = String(get(opt, 'component_name', get(opt, 'label', ''))).trim().toLowerCase();
      if (!key) return;
      byName.set(key, opt);
    };

    // low -> high priority
    (Array.isArray(fallback) ? fallback : []).forEach(put);
    (Array.isArray(apiOptions) ? apiOptions : []).forEach(put);
    (Array.isArray(localOptions) ? localOptions : []).forEach(put);

    return Array.from(byName.values());
  };
  const getModifiedScanExistingOptions = (assetId: string, fallback: any[] = []) => {
    const apiOptions = get(assetComponents, `${assetId}.components`, []);
    const localOptions = getLocalAssetOptions(assetId);
    const byName = new Map<string, any>();
    const mergeOption = (base: any, incoming: any) => {
      if (!base) return incoming;
      if (!incoming) return base;

      const baseData = get(base, 'data', {});
      const incomingData = get(incoming, 'data', {});

      return {
        ...base,
        ...incoming,
        id: incoming?.id ?? base?.id,
        uuid: incoming?.uuid ?? base?.uuid,
        component_id: incoming?.component_id ?? base?.component_id,
        service_id: incoming?.service_id ?? base?.service_id,
        component_name: incoming?.component_name ?? base?.component_name,
        label: incoming?.label ?? base?.label,
        data: {
          ...baseData,
          ...incomingData,
          messages: incomingData?.messages ?? baseData?.messages,
          scan_result: incomingData?.scan_result ?? baseData?.scan_result,
        },
      };
    };

    const put = (opt: any) => {
      const key = String(get(opt, 'component_name', get(opt, 'label', ''))).trim().toLowerCase();
      if (!key) return;
      byName.set(key, mergeOption(byName.get(key), opt));
    };

    (Array.isArray(fallback) ? fallback : []).forEach(put);
    (Array.isArray(apiOptions) ? apiOptions : []).forEach(put);
    (Array.isArray(localOptions) ? localOptions : []).forEach(put);

    return Array.from(byName.values());
  };
  const getExistingOptionsForPair = (pair: any): any[] => {
    const assetId = String(get(pair, 'existingAsset.id', '')).trim();
    if (!assetId) return [];

    const fallbackNode = get(pair, 'existingAsset.data.options', []);
    const fallbackApi = get(pair, 'existingAsset.components', []);
    const fallback = [
      ...(Array.isArray(fallbackNode) ? fallbackNode : []),
      ...(Array.isArray(fallbackApi) ? fallbackApi : []),
    ];

    return getEffectiveExistingOptions(assetId, fallback);
  };

  const mergeComponentOptions = (existingOpt: any, importedOpt: any, propSchema: Record<string, any> = {}, messageSchema: Record<string, any> = {}): any => {
    const isMeaningful = (value: any) => {
      if (value === null || value === undefined) return false;
      if (typeof value === 'string') return value.trim() !== '';
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return true;
    };

    //After merge the existing and imported options, we need to make sure that the secret fields are not overwritten by empty values. So we need to get the component name and then get the secret fields for that component and then check if the imported option has any of those secret fields and if it does, we need to keep the existing value for that field.
    // const componentNameKey = String(
    //   get(importedOpt, 'component_name', get(existingOpt, 'component_name', get(importedOpt, 'label', get(existingOpt, 'label', ''))))
    // )
    //   .trim()
    //   .toLowerCase();
    // const componentSecretFieldsByName = getComponentSecretFieldsByName();
    // const secretFieldKeys = new Set(
    //   (componentSecretFieldsByName.get(componentNameKey) || []).map((field) => String(field?.key || '').trim())
    // );

    const existingData = existingOpt?.data || {};
    const importedData = importedOpt?.data || {};

    const mergedData: Record<string, any> = { ...existingData };
    const hasImportedMessages = Object.prototype.hasOwnProperty.call(importedData, 'messages');

    Object.keys(importedData).forEach((key) => {
      if (key === 'messages') return;

      const importedVal = importedData[key];
      const existingVal = existingData[key];

      if (Array.isArray(importedVal)) {
        mergedData[key] = importedVal.length > 0 ? importedVal : (Array.isArray(existingVal) ? existingVal : []);
        return;
      }

      if (
        importedVal &&
        typeof importedVal === 'object' &&
        !Array.isArray(importedVal) &&
        existingVal &&
        typeof existingVal === 'object' &&
        !Array.isArray(existingVal)
      ) {
        mergedData[key] = {
          ...existingVal,
          ...importedVal,
        };
        return;
      }

      if (isMeaningful(importedVal)) {
        mergedData[key] = importedVal;
        return;
      }

      if (!(key in mergedData)) {
        mergedData[key] = existingVal;
      }
    });

    if (hasImportedMessages) {
      const importedMessages = Array.isArray(importedData.messages) ? importedData.messages : [];
      const existingMessages = Array.isArray(existingData?.messages) ? existingData.messages : [];

      // Derive message identity field from x-messageKey marker; fallback to 'id' then 'name'.
      const msgKeyField = Object.keys(messageSchema).find(
        (k) => get(messageSchema[k], 'x-messageKey') === true
      ) ?? 'id';
      const normalizeMessageKey = (msg: any) =>
        String(get(msg, msgKeyField, get(msg, 'name', ''))).trim().toLowerCase();

      const existingByKey = new Map<string, any>(
        existingMessages.map((msg: any) => [normalizeMessageKey(msg), msg])
      );

      const nextMessages: any[] = [];

      // Update matched existing messages in-place; preserve unmatched existing messages.
      existingMessages.forEach((existingMsg: any) => {
        const key = normalizeMessageKey(existingMsg);
        const matched = importedMessages.find((imp: any) => normalizeMessageKey(imp) === key);

        if (!matched) {
          nextMessages.push(JSON.parse(JSON.stringify(existingMsg)));
          return;
        }

        // Overlay imported message fields onto existing, but merge props by union.
        const mergedMsg = { ...existingMsg, ...matched };

        const existingProps = Array.isArray(existingMsg.props) ? existingMsg.props : [];
        const importedProps = Array.isArray(matched.props) ? matched.props : [];

        if (existingProps.length > 0 || importedProps.length > 0) {
          // Derive merge identity field from x-scanValidate marker; fallback to 'id'.
          const mergeKeyField = Object.keys(propSchema).find(
            (k) => get(propSchema[k], 'x-scanValidate') === true
          ) ?? 'id';
          const normParamKey = (prop: any) => String(get(prop, mergeKeyField, '')).trim().toLowerCase();

          const existingPropsByKey = new Map<string, any>(
            existingProps
              .filter((p: any) => String(get(p, mergeKeyField, '')).trim())
              .map((p: any) => [normParamKey(p), p])
          );

          const nextProps: any[] = [];

          // Keep all existing props, updating any that also appear in imported by id.
          existingProps.forEach((existingProp: any) => {
            const pKey = normParamKey(existingProp);
            const matchedProp = pKey ? importedProps.find((imp: any) => normParamKey(imp) === pKey) : null;
            nextProps.push(matchedProp ? { ...existingProp, ...matchedProp } : existingProp);
          });

          // Append props from imported that have no matching existing entry.
          importedProps.forEach((importedProp: any) => {
            const pKey = normParamKey(importedProp);
            if (!pKey || !existingPropsByKey.has(pKey)) {
              nextProps.push(importedProp);
            }
          });

          mergedMsg.props = nextProps;
        }

        nextMessages.push(JSON.parse(JSON.stringify(mergedMsg)));
      });

      // Append imported messages that don't exist yet.
      importedMessages.forEach((importedMsg: any) => {
        if (!existingByKey.has(normalizeMessageKey(importedMsg))) {
          nextMessages.push(JSON.parse(JSON.stringify(importedMsg)));
        }
      });

      mergedData.messages = nextMessages;
    } else if (Array.isArray(existingData?.messages)) {
      mergedData.messages = JSON.parse(JSON.stringify(existingData.messages));
    }

    return {
      ...existingOpt,
      ...importedOpt,
      id: existingOpt?.id ?? importedOpt?.id,
      uuid: existingOpt?.uuid ?? importedOpt?.uuid,
      component_id: existingOpt?.component_id ?? importedOpt?.component_id,
      service_id: existingOpt?.service_id ?? importedOpt?.service_id,
      component_name: importedOpt?.component_name ?? existingOpt?.component_name,
      label: importedOpt?.label ?? existingOpt?.label,
      enabled:
        typeof importedOpt?.enabled !== 'undefined'
          ? Boolean(importedOpt.enabled)
          : Boolean(existingOpt?.enabled ?? true),
      data: mergedData,
    };
  };


  const tagResolvedOption = (option: any, source: any) => ({
    ...option,
    __duplicateResolutionSource: source,
  });

  const buildAssetsFromDuplicateStrategy = (
    strategy: 'overwrite' | 'skip' | 'merge' | null,
    candidateAssets: any[],
    duplicatePairs: Array<{
      importedIndex: number;
      existingNodeId: string;
      importedAsset: any;
      existingAsset: any;
      componentOverlaps: string[];
    }>,
    rowStrategies: Record<string, 'overwrite' | 'skip' | 'merge'> = {}
  ) => {
    const normalizeComponentKey = (value: any) => String(value ?? '').trim().toLowerCase();

    const normalizedRowStrategies: Record<string, 'overwrite' | 'skip' | 'merge'> =
      Object.entries(rowStrategies).reduce((acc, [rawKey, rawValue]) => {
        const [indexPart, ...componentParts] = String(rawKey).split('-');
        const componentPart = componentParts.join('-');
        if (!indexPart || !componentPart) return acc;

        const normalizedKey = `${indexPart}-${componentPart.trim().toLowerCase()}`;
        acc[normalizedKey] = rawValue;
        return acc;
      }, {} as Record<string, 'overwrite' | 'skip' | 'merge'>);

    const duplicateByIndex = new Map<number, (typeof duplicatePairs)[number]>();
    duplicatePairs.forEach((pair) => duplicateByIndex.set(pair.importedIndex, pair));

    const resolvedAssets: any[] = [];
    const removeExistingAssetNodeIds: string[] = [];
    const updateExistingAssets: Array<{
      nodeId: string;
      options: any[];
      data?: any;
    }> = [];

    candidateAssets.forEach((asset, index) => {
      const pair = duplicateByIndex.get(index);

      if (!pair) {
        resolvedAssets.push(asset);
        return;
      }

      const assetLevelKey = `${index}-${String(ASSET_LEVEL_DUPLICATE_COMPONENT_KEY || '')}`;
      const assetLevelStrategy = normalizedRowStrategies[assetLevelKey] ?? null;
      const defaultStrategy = assetLevelStrategy ?? strategy ?? 'merge';

      const hasComponentLevelOverride = Object.keys(normalizedRowStrategies).some(
        (key) => key.startsWith(`${index}-`) && key !== assetLevelKey
      );

      const existingOptions = (getExistingOptionsForPair(pair) || []) as any[];
      const importedOptions = (get(asset, 'data.options', []) || []) as any[];

      const existingByName = new Map<string, any>(
        existingOptions
          .map((opt: any) => {
            const key = normalizeComponentKey(getNormalizedComponentName(opt));
            return key ? [key, opt] : null;
          })
          .filter(Boolean) as [string, any][]
      );

      const importedByName = new Map<string, any>(
        importedOptions
          .map((opt: any) => {
            const key = normalizeComponentKey(getNormalizedComponentName(opt));
            return key ? [key, opt] : null;
          })
          .filter(Boolean) as [string, any][]
      );

      // const assetUpdateData =
      //   asset?.data && typeof asset.data === 'object'
      //     ? ['name', 'ip', 'enabled'].reduce((acc: Record<string, any>, key) => {
      //         if (Object.prototype.hasOwnProperty.call(asset.data, key)) {
      //           acc[key] = asset.data[key];
      //         }
      //         return acc;
      //       }, {})
      //     : {};

      const importedAssetUpdateData =
        asset?.data && typeof asset.data === 'object'
          ? ['name', 'ip', 'enabled'].reduce((acc: Record<string, any>, key) => {
            if (Object.prototype.hasOwnProperty.call(asset.data, key)) {
              acc[key] = asset.data[key];
            }
            return acc;
          }, {})
          : {};

      if (defaultStrategy === 'skip' && !hasComponentLevelOverride) {
        return;
      }

      if (defaultStrategy === 'overwrite' && !hasComponentLevelOverride) {
        resolvedAssets.push(asset);
        removeExistingAssetNodeIds.push(pair.existingNodeId);
        return;
      }

      const allNames = new Set<string>([
        ...Array.from(existingByName.keys()),
        ...Array.from(importedByName.keys()),
      ]);

      const nextOptionsMap = new Map<string, any>();

      allNames.forEach((name) => {
        const existingOpt = existingByName.get(name);
        const importedOpt = importedByName.get(name);

        const componentRowKey = `${index}-${name}`;
        const componentStrategy =
          normalizedRowStrategies[componentRowKey] ??
          assetLevelStrategy ??
          strategy ??
          'merge';

        if (componentStrategy === 'skip') {
          if (existingOpt) {
            nextOptionsMap.set(name, tagResolvedOption(existingOpt, 'existing'));
          }
          return;
        }

        if (componentStrategy === 'overwrite') {
          if (importedOpt && existingOpt) {
            const replaced = {
              ...importedOpt,
              id: existingOpt.id ?? importedOpt.id,
              uuid: existingOpt.uuid ?? importedOpt.uuid,
              component_id: existingOpt.component_id ?? importedOpt.component_id,
              service_id: existingOpt.service_id ?? importedOpt.service_id,
            };
            nextOptionsMap.set(name, tagResolvedOption(replaced, 'merged')); // critical
          } else if (importedOpt) {
            nextOptionsMap.set(name, tagResolvedOption(importedOpt, 'imported'));
          } else if (existingOpt) {
            nextOptionsMap.set(name, tagResolvedOption(existingOpt, 'existing'));
          }
          return;
        }

        if (existingOpt && importedOpt) {
          const schemaEntry = componentSchemaMapMemo[name] || {};
          const parsedBackendSchema = safeParseSchema(get(schemaEntry, 'backend_schema')) || {};
          const messageSchema: Record<string, any> = get(parsedBackendSchema, 'properties.messages.items.properties', {});
          const propSchema: Record<string, any> = get(messageSchema, 'props.items.properties', {});
          nextOptionsMap.set(
            name,
            tagResolvedOption(
              mergeComponentOptions(existingOpt, importedOpt, propSchema, messageSchema),
              'merged'
            )
          );
          return;
        }

        if (!existingOpt && importedOpt) {
          nextOptionsMap.set(name, tagResolvedOption(importedOpt, 'imported'));
          return;
        }

        if (existingOpt) {
          nextOptionsMap.set(name, tagResolvedOption(existingOpt, 'existing'));
        }
      });

      const resolvedOptions = Array.from(nextOptionsMap.values());

      if (resolvedOptions.length === 0) {
        return;
      }
      const hasAnyNonSkipComponentOverride = Object.keys(normalizedRowStrategies).some((key) => {
        if (!key.startsWith(`${index}-`) || key === assetLevelKey) return false;
        return normalizedRowStrategies[key] !== 'skip';
      });

      const shouldApplyAssetLevelData =
        assetLevelStrategy === 'overwrite' ||
        assetLevelStrategy === 'merge' ||
        (!assetLevelStrategy &&
          (
            strategy === 'overwrite' ||
            strategy === 'merge' ||
            hasAnyNonSkipComponentOverride
          ));

      updateExistingAssets.push({
        nodeId: pair.existingNodeId,
        options: resolvedOptions,
        ...(shouldApplyAssetLevelData && Object.keys(importedAssetUpdateData).length > 0
          ? { data: importedAssetUpdateData }
          : {}),
      });

      // updateExistingAssets.push({
      //   nodeId: pair.existingNodeId,
      //   options: resolvedOptions,
      //   ...(Object.keys(assetUpdateData).length > 0 ? { data: assetUpdateData } : {}),
      // });
    });

    return {
      resolvedAssets,
      removeExistingAssetNodeIds,
      updateExistingAssets,
    };
  };

  const { pathname } = useLocation();
  const [flowData, setFlowData] = useState<any[]>([]);
  const dispatch = useDispatch();
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const outletData: any = get(useOutletContext(), 'outletData', {});
  const getComponentDetails: any = {
    factory: {
      titleTag: get(outletData, 'site_factory.entity_name', factoryLabel),
    },
    useCase: {
      titleTag: 'Use Case',
    },
  };

  const getCompoDetails = get(
    getComponentDetails,
    pathname.split('/').includes('factory-management') ? 'factory' : 'useCase',
    {}
  );
  // const { useCaseId } = useParams();  
  const matchedRoute = matchRoutes(routePaths, pathname);
  const hasAccessTo = get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}`, {});

  useEffect(() => {
    if (importPreview.open || !queuedImportDuplicateModal) return;

    // wait for batch data if requested
    if (isWaitingDuplicateBatch && pendingDuplicateAssetIds.length > 0) {
      const allLoaded = pendingDuplicateAssetIds.every(
        (assetId) => Array.isArray(get(assetComponents, `${assetId}.components`, null))
      );
      if (!allLoaded) return;
    }

    setImportDuplicateModal({
      open: true,
      strategy: queuedImportDuplicateModal.strategy,
      candidateAssets: queuedImportDuplicateModal.candidateAssets,
      totalCandidateAssets: queuedImportDuplicateModal.totalCandidateAssets,
      duplicatePairs: queuedImportDuplicateModal.duplicatePairs,
      selectedGatewayId: queuedImportDuplicateModal.selectedGatewayId,
      selectedGatewayData: queuedImportDuplicateModal.selectedGatewayData,
    });

    setQueuedImportDuplicateModal(null);
    setPendingDuplicateAssetIds([]);
    setIsWaitingDuplicateBatch(false);
    setIsPreparingData(false);
  }, [
    importPreview.open,
    queuedImportDuplicateModal,
    isWaitingDuplicateBatch,
    pendingDuplicateAssetIds,
    assetComponents,
  ]);

  useEffect(() => {
    if (!isWaitingDuplicateBatch || !queuedImportDuplicateModal) return;

    const t = setTimeout(() => {
      // Fallback: proceed with existing/fallback data if batch API is slow/fails
      setIsWaitingDuplicateBatch(false);
    }, 1500);

    return () => clearTimeout(t);
  }, [isWaitingDuplicateBatch, queuedImportDuplicateModal]);

  useEffect(() => {
    if (!queuedModifiedScanRequest) return;

    // While waiting=true, wait for batch response if there are pending asset ids.
    // After timeout flips waiting=false, this gate is skipped and we proceed with fallback data.
    if (isWaitingModifiedScanBatch && pendingModifiedScanAssetIds.length > 0) {
      const allLoaded = pendingModifiedScanAssetIds.every(
        (assetId) => Array.isArray(get(assetComponents, `${assetId}.components`, null))
      );
      if (!allLoaded) return;
    }

    const modifiedScanPlan = deriveModifiedScanPlan(
      queuedModifiedScanRequest.candidateAssets,
      queuedModifiedScanRequest.selectedGatewayId
    );
    const assetsForNextStep = modifiedScanPlan.assets;
    const scanAssetIndexes = modifiedScanPlan.scanAssetIndexes;

    setImportPreview((s) => ({
      ...s,
      open: scanAssetIndexes.length > 0,
      assets: assetsForNextStep,
    }));

    if (scanAssetIndexes.length === 0) {
      Snackbar.info('No assets require scan based on existing scan_result. Opening message validation directly.');
      setImportScanModal({
        open: false,
        assets: [],
        scanAssetIndexes: [],
        selectedGatewayId: null,
        selectedGatewayData: null,
      });
      setImportMessageValidationModal({
        open: true,
        assets: assetsForNextStep,
        failedAssetIndexes: [],
        selectedGatewayId: queuedModifiedScanRequest.selectedGatewayId,
        selectedGatewayData: queuedModifiedScanRequest.selectedGatewayData,
      });
    } else {
      setImportScanModal({
        open: true,
        assets: assetsForNextStep,
        scanAssetIndexes,
        selectedGatewayId: queuedModifiedScanRequest.selectedGatewayId,
        selectedGatewayData: queuedModifiedScanRequest.selectedGatewayData,
      });
    }

    setQueuedModifiedScanRequest(null);
    setPendingModifiedScanAssetIds([]);
    setIsWaitingModifiedScanBatch(false);
    setIsPreparingData(false);
  }, [
    queuedModifiedScanRequest,
    isWaitingModifiedScanBatch,
    pendingModifiedScanAssetIds,
    assetComponents,
  ]);

  useEffect(() => {
    if (!isWaitingModifiedScanBatch || !queuedModifiedScanRequest) return;

    const t = setTimeout(() => {
      // Fallback path: stop waiting and let the effect above proceed with best available data.
      setIsWaitingModifiedScanBatch(false);
    }, 1500);

    return () => clearTimeout(t);
  }, [isWaitingModifiedScanBatch, queuedModifiedScanRequest]);

  useEffect(() => {
    if (rowId) {
      // dispatch(buildUseCaseActions.getUseCaseDataRequest(useCaseId));
      // onDataRequest();
      dispatch(gatewayMasterActions.getGatewayDataRequest());
      dispatch(machineryManagementActions.getMachineryManagementDataRequest());
      dispatch(componentMasterActions.getServicesDataRequest());
      dispatch(platformServicesMasterActions.getServicesDataRequest());
      dispatch(secretManagerActions.getSecretsRequest({ page: 1, limit: 1000 }));
      // dispatch(buildUseCaseActions.getAllUseCasesDataRequest(''));
      dispatch(factoryManagementActions.getFactoriesList());
    }
    return () => {
      dispatch(factoryManagementActions.resetLoadingState());
    };
  }, [rowId]);

  const SuccessSnackBar = (msg: any) => {
    dispatch(buildUseCaseActions.resetLoadingState());
    Snackbar.success(msg);
  };



  const {
    unityProvider,
    isLoaded,
    sendMessage,
    addEventListener,
    removeEventListener,
    // UNSAFE__detachAndUnloadImmediate,
    unload,
  } = useUnityContext({
    loaderUrl: '/webgl/Build/WebGL-Export.loader.js',
    dataUrl: '/webgl/Build/WebGL-Export.data',
    frameworkUrl: '/webgl/Build/WebGL-Export.framework.js',
    codeUrl: '/webgl/Build/WebGL-Export.wasm',
  });

  useEffect(() => {
    const cb = () => {

      //const json = {"machineID":"Chiller1","machineName":"Chiller","machineDescription":"","machinePath":"https://drive.google.com/uc?export=download&id=1VOCf09EdNAZ8PshOO6Hg1fHyyORtf_54","uniqueID":"-","position":{"x":0,"y":0,"z":0},"rotation":{"x":0,"y":0,"z":0},"scale":{"x":0,"y":0,"z":0},"parameters":[{"parameterID":"temperature","name":"temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":3.3,"max":15.6,"idealReading":6.6},{"parameterID":"humidity","name":"humidity","description":"","type":"Float","unit":"degreeC","value":0,"min":-28.49,"max":43.4,"idealReading":9},{"parameterID":"var_entering_chilled_temp1","name":"Entering Chilled Liquid Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":-28.49,"max":43.4,"idealReading":15},{"parameterID":"var_variable_speed_drive_int_ambient_temp1","name":"Variable Speed Drive Internal Ambient Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":0,"max":70,"idealReading":61.6},{"parameterID":"var_leaving_liquid_temp1","name":"Leaving Condenser Liquid Temp","description":"","type":"Float","unit":"degreeC","value":0,"min":-7.31,"max":79.7,"idealReading":9},{"parameterID":"var_sys1_discharge_temp1","name":"System1 Discharge Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":4.61,"max":150,"idealReading":20},{"parameterID":"var_entering_liquid_temp1","name":"Entering Condenser Liquid Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":-28.49,"max":43.4,"idealReading":9},{"parameterID":"var_sys1_oil_pressure1","name":"System1 Oil Pressure","description":"","type":"Float","unit":"PSIG","value":0,"min":0,"max":400,"idealReading":130},{"parameterID":"var_sys1_evaporator_pressure1","name":"System1 Evaporator Pressure","description":"","type":"PSIG","value":0,"min":0,"max":125,"idealReading":125},{"parameterID":"var_sys1_discharge_pressure1","name":"System1 Discharge Pressure","description":"","type":"PSIG","value":0,"min":0,"max":400,"idealReading":131},{"parameterID":"var_sys1_compressor_full_load1","name":"System1 Compressor Full Load","description":"","type":"None","unit":"%","value":0,"min":0,"max":1,"idealReading":0},{"parameterID":"var_sys1_total_run_hours1","name":"System1 Total Run Hours","description":"","type":"None","unit":"Hr","value":0,"min":0,"max":1,"idealReading":0},{"parameterID":"var_sys1_highest_motor_temp1","name":"System1 Highest Motor Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":-34.56,"max":150,"idealReading":50},{"parameterID":"var_sys2_highest_motor_temp1","name":"System2 Highest Motor Temperature","description":"","type":"Float","unit":"degreeC","value":0,"min":-34.56,"max":150,"idealReading":50},{"parameterID":"var_sys1_economizer_pressure1","name":"System1 Economizer Pressure","description":"","type":"Float","unit":"degreeC","value":0,"min":-7.31,"max":79.7,"idealReading":48.8},{"parameterID":"var_sys2_oil_pressure1","name":"System2 Oil Pressure","description":"","type":"Float","unit":"PSIG","value":0,"min":0,"max":400,"idealReading":130},{"parameterID":"var_sys2_evaporator_pressure1","name":"System2 Evaporator Pressure","description":"","type":"PSIG","value":0,"min":0,"max":125,"idealReading":125},{"parameterID":"var_sys2_discharge_pressure1","name":"System2 Discharge Pressure","description":"","type":"PSIG","value":0,"min":0,"max":400,"idealReading":131},{"parameterID":"var_ambient_temperature1","name":"Ambient Temperature","description":"","type":"Float","unit":"PSIG","value":0,"min":0,"max":0,"idealReading":-1},{"parameterID":"var_remote_start_stop1","name":"Remote Start Stop","description":"","type":"Switch","unit":"","value":0,"min":0,"max":1,"idealReading":0},{"parameterID":"var_compressor_on_off1","name":"Compressor Start Stop","description":"","type":"Switch","unit":"","value":0,"min":0,"max":1,"idealReading":0},{"parameterID":"var_sys1_total_num_of_starts1","name":"System1 Total Number of Starts","description":"","type":"None","unit":"","value":0,"min":0,"max":1,"idealReading":0}],"Bubbles":[]};
      sendMessage('SceneLoader', 'LoadFactoryConfigurator', '');
    };
    addEventListener('SceneLoaderReady', cb);
    return () => removeEventListener('SceneLoaderReady', cb);
  }, [sendMessage, isLoaded]);

  useEffect(() => {
    const cb = () => {

      //http://${window.location.host}/webgl/Build/Parth.glb
      const json = {
        Machines: [
          {
            machineID: 'Screwing_Machine_01',
            machineName: 'Screwing Machine',
            machineDescription: '',
            machinePath: `http://${window.location.host}/webgl/Build/Parth.glb`,
            uniqueID: '-',
            position: { x: 0, y: 0, z: 0 },
            rotation: { x: 0, y: 0, z: 0 },
            scale: { x: 0, y: 0, z: 0 },
            parameters: [
              {
                parameterID: 'var_chilled_liquid_temp_setpoint1',
                name: 'Chilled Liquid Temperature SP',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 3.3,
                max: 15.6,
                idealReading: 6.6,
              },
              {
                parameterID: 'var_leaving_chilled_temp1',
                name: 'Leaving Chilled Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 9,
              },
              {
                parameterID: 'var_entering_chilled_temp1',
                name: 'Entering Chilled Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 15,
              },
              {
                parameterID: 'var_variable_speed_drive_int_ambient_temp1',
                name: 'Variable Speed Drive Internal Ambient Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 0,
                max: 70,
                idealReading: 61.6,
              },
              {
                parameterID: 'var_leaving_liquid_temp1',
                name: 'Leaving Condenser Liquid Temp',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -7.31,
                max: 79.7,
                idealReading: 9,
              },
              {
                parameterID: 'var_sys1_discharge_temp1',
                name: 'System1 Discharge Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 4.61,
                max: 150,
                idealReading: 20,
              },
              {
                parameterID: 'var_entering_liquid_temp1',
                name: 'Entering Condenser Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 9,
              },
              {
                parameterID: 'var_sys1_oil_pressure1',
                name: 'System1 Oil Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 130,
              },
              {
                parameterID: 'var_sys1_evaporator_pressure1',
                name: 'System1 Evaporator Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 125,
                idealReading: 125,
              },
              {
                parameterID: 'var_sys1_discharge_pressure1',
                name: 'System1 Discharge Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 131,
              },
              {
                parameterID: 'var_sys1_compressor_full_load1',
                name: 'System1 Compressor Full Load',
                description: '',
                type: 'None',
                unit: '%',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_total_run_hours1',
                name: 'System1 Total Run Hours',
                description: '',
                type: 'None',
                unit: 'Hr',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_highest_motor_temp1',
                name: 'System1 Highest Motor Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -34.56,
                max: 150,
                idealReading: 50,
              },
              {
                parameterID: 'var_sys2_highest_motor_temp1',
                name: 'System2 Highest Motor Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -34.56,
                max: 150,
                idealReading: 50,
              },
              {
                parameterID: 'var_sys1_economizer_pressure1',
                name: 'System1 Economizer Pressure',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -7.31,
                max: 79.7,
                idealReading: 48.8,
              },
              {
                parameterID: 'var_sys2_oil_pressure1',
                name: 'System2 Oil Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 130,
              },
              {
                parameterID: 'var_sys2_evaporator_pressure1',
                name: 'System2 Evaporator Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 125,
                idealReading: 125,
              },
              {
                parameterID: 'var_sys2_discharge_pressure1',
                name: 'System2 Discharge Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 131,
              },
              {
                parameterID: 'var_ambient_temperature1',
                name: 'Ambient Temperature',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 0,
                idealReading: -1,
              },
              {
                parameterID: 'var_remote_start_stop1',
                name: 'Remote Start Stop',
                description: '',
                type: 'Switch',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_compressor_on_off1',
                name: 'Compressor Start Stop',
                description: '',
                type: 'Switch',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_total_num_of_starts1',
                name: 'System1 Total Number of Starts',
                description: '',
                type: 'None',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
            ],
            Bubbles: [
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_chilled_liquid_temp_setpoint1',
                  name: 'Chilled Liquid Temperature SP',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: 3.3,
                  max: 15.6,
                  idealReading: 6.6,
                },
                position: { x: -2.260319, y: 2.581949, z: -2.377136 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_leaving_chilled_temp1',
                  name: 'Leaving Chilled Liquid Temperature',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: -28.49,
                  max: 43.4,
                  idealReading: 9,
                },
                position: { x: 0.05374527, y: 2.335068, z: 1.119469 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_entering_chilled_temp1',
                  name: 'Entering Chilled Liquid Temperature',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: -28.49,
                  max: 43.4,
                  idealReading: 15,
                },
                position: { x: -2.392128, y: 1.796257, z: 1.363937 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
            ],
          },
          {
            machineID: 'Welding_Machine_01',
            machineName: 'Welding Machine',
            machineDescription: '',
            machinePath: `http://${window.location.host}/webgl/Build/Parth.glb`,
            uniqueID: '-',
            position: { x: 0, y: 0, z: 0 },
            rotation: { x: 0, y: 0, z: 0 },
            scale: { x: 0, y: 0, z: 0 },
            parameters: [
              {
                parameterID: 'var_chilled_liquid_temp_setpoint1',
                name: 'Chilled Liquid Temperature SP',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 3.3,
                max: 15.6,
                idealReading: 6.6,
              },
              {
                parameterID: 'var_leaving_chilled_temp1',
                name: 'Leaving Chilled Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 9,
              },
              {
                parameterID: 'var_entering_chilled_temp1',
                name: 'Entering Chilled Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 15,
              },
              {
                parameterID: 'var_variable_speed_drive_int_ambient_temp1',
                name: 'Variable Speed Drive Internal Ambient Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 0,
                max: 70,
                idealReading: 61.6,
              },
              {
                parameterID: 'var_leaving_liquid_temp1',
                name: 'Leaving Condenser Liquid Temp',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -7.31,
                max: 79.7,
                idealReading: 9,
              },
              {
                parameterID: 'var_sys1_discharge_temp1',
                name: 'System1 Discharge Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: 4.61,
                max: 150,
                idealReading: 20,
              },
              {
                parameterID: 'var_entering_liquid_temp1',
                name: 'Entering Condenser Liquid Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -28.49,
                max: 43.4,
                idealReading: 9,
              },
              {
                parameterID: 'var_sys1_oil_pressure1',
                name: 'System1 Oil Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 130,
              },
              {
                parameterID: 'var_sys1_evaporator_pressure1',
                name: 'System1 Evaporator Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 125,
                idealReading: 125,
              },
              {
                parameterID: 'var_sys1_discharge_pressure1',
                name: 'System1 Discharge Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 131,
              },
              {
                parameterID: 'var_sys1_compressor_full_load1',
                name: 'System1 Compressor Full Load',
                description: '',
                type: 'None',
                unit: '%',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_total_run_hours1',
                name: 'System1 Total Run Hours',
                description: '',
                type: 'None',
                unit: 'Hr',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_highest_motor_temp1',
                name: 'System1 Highest Motor Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -34.56,
                max: 150,
                idealReading: 50,
              },
              {
                parameterID: 'var_sys2_highest_motor_temp1',
                name: 'System2 Highest Motor Temperature',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -34.56,
                max: 150,
                idealReading: 50,
              },
              {
                parameterID: 'var_sys1_economizer_pressure1',
                name: 'System1 Economizer Pressure',
                description: '',
                type: 'Float',
                unit: 'degreeC',
                value: 0,
                min: -7.31,
                max: 79.7,
                idealReading: 48.8,
              },
              {
                parameterID: 'var_sys2_oil_pressure1',
                name: 'System2 Oil Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 130,
              },
              {
                parameterID: 'var_sys2_evaporator_pressure1',
                name: 'System2 Evaporator Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 125,
                idealReading: 125,
              },
              {
                parameterID: 'var_sys2_discharge_pressure1',
                name: 'System2 Discharge Pressure',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 400,
                idealReading: 131,
              },
              {
                parameterID: 'var_ambient_temperature1',
                name: 'Ambient Temperature',
                description: '',
                type: 'Float',
                unit: 'PSIG',
                value: 0,
                min: 0,
                max: 0,
                idealReading: -1,
              },
              {
                parameterID: 'var_remote_start_stop1',
                name: 'Remote Start Stop',
                description: '',
                type: 'Switch',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_compressor_on_off1',
                name: 'Compressor Start Stop',
                description: '',
                type: 'Switch',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
              {
                parameterID: 'var_sys1_total_num_of_starts1',
                name: 'System1 Total Number of Starts',
                description: '',
                type: 'None',
                unit: '',
                value: 0,
                min: 0,
                max: 1,
                idealReading: 0,
              },
            ],
            Bubbles: [
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_chilled_liquid_temp_setpoint1',
                  name: 'Chilled Liquid Temperature SP',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: 3.3,
                  max: 15.6,
                  idealReading: 6.6,
                },
                position: { x: -2.260319, y: 2.581949, z: -2.377136 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_leaving_chilled_temp1',
                  name: 'Leaving Chilled Liquid Temperature',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: -28.49,
                  max: 43.4,
                  idealReading: 9,
                },
                position: { x: 0.05374527, y: 2.335068, z: 1.119469 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
              {
                ID: '',
                mappedParameter: {
                  parameterID: 'var_entering_chilled_temp1',
                  name: 'Entering Chilled Liquid Temperature',
                  description: '',
                  type: 'Float',
                  unit: 'degreeC',
                  value: 0,
                  min: -28.49,
                  max: 43.4,
                  idealReading: 15,
                },
                position: { x: -2.392128, y: 1.796257, z: 1.363937 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: 1, y: 1, z: 1 },
              },
            ],
          },
        ],
      };
      sendMessage('DataManager', 'loadFactoryMachineList', JSON.stringify(json));
    };
    addEventListener('FactoryConfigInitComplete', cb);
    return () => removeEventListener('FactoryConfigInitComplete', cb);
  }, [sendMessage, isLoaded]);

  const FailedSnackBar = (msg: any) => {
    dispatch(buildUseCaseActions.resetLoadingState());
    Snackbar.error(msg);
  };

  const safeParseSchema = (input: any) => {
    if (!input) return null;
    if (typeof input === 'object') return input;
    if (typeof input !== 'string') return null;

    try {
      return JSON.parse(input);
    } catch {
      return null;
    }
  };

  const renderScanPayloadTemplate = (payloadTemplate: any, data: Record<string, any>): any => {
    if (Array.isArray(payloadTemplate)) {
      return payloadTemplate.map((item) => renderScanPayloadTemplate(item, data));
    }

    if (payloadTemplate && typeof payloadTemplate === 'object') {
      const result: any = {};
      Object.keys(payloadTemplate).forEach((key) => {
        const value = renderScanPayloadTemplate(payloadTemplate[key], data);
        if (value !== undefined && value !== null) {
          result[key] = value;
        }
      });
      return result;
    }

    if (typeof payloadTemplate === 'string') {
      const exactMatch = payloadTemplate.match(/^{{(.*?)}}$/);
      if (exactMatch) {
        const dataKey = exactMatch[1].trim();
        const value = dataKey.split('.').reduce((acc: any, part: string) => acc && acc[part], data);
        if (value !== undefined && value !== null && value !== '') return value;
        return undefined;
      }

      return payloadTemplate.replace(/{{(.*?)}}/g, (_, key) => {
        const value = key
          .trim()
          .split('.')
          .reduce((acc: any, part: string) => acc && acc[part], data);
        if (value === undefined || value === null) return '';
        return typeof value === 'object' ? JSON.stringify(value) : String(value);
      });
    }

    return payloadTemplate;
  };

  const normalizeImportScanResult = (rawResult: any, scanResultSchema: any): any[] => {
    if (rawResult === null || rawResult === undefined) return [];

    const schema = scanResultSchema && typeof scanResultSchema === 'object' ? scanResultSchema : {};
    const scanResultType = get(schema, 'type');
    const scanResultSchemaKey = get(schema, 'rootKey');
    const scanResultSchemaColumns = get(schema, 'columns', []);

    const flattenData = (tag: any): any[] => {
      if (!tag || typeof tag !== 'object') return [];
      const children = Array.isArray(tag.children) ? tag.children : [];
      return [tag, ...children.flatMap(flattenData)];
    };

    if (scanResultType === 'object') {
      const source =
        scanResultSchemaKey && rawResult && typeof rawResult === 'object'
          ? rawResult[scanResultSchemaKey]
          : rawResult;

      if (Array.isArray(source) && source.length > 0) {
        if (source[0] && typeof source[0] === 'object') {
          if (scanResultSchemaColumns.length) {
            return source.map((item: Record<string, any>) => {
              return scanResultSchemaColumns.reduce((acc: Record<string, any>, col: any) => {
                const key = get(col, 'value');
                if (!key) return acc;
                acc[key] = item?.[key];
                return acc;
              }, {} as Record<string, any>);
            });
          }
          return source;
        }

        if (typeof source[0] === 'string') {
          const firstColumn = get(scanResultSchemaColumns, '[0].value', 'Name');
          return source.map((value: string) => ({ [firstColumn]: value }));
        }

        return [];
      }

      if (source && typeof source === 'object') {
        const flattened = flattenData(source)
          .filter((tag: any) => !!tag?.type && tag?.datatype !== 'Unsupported')
          .map((tag: any) => {
            const next = { ...tag };
            delete next.children;
            return next;
          });

        if (flattened.length > 0) return flattened;

        if (scanResultSchemaColumns.length) {
          return [
            scanResultSchemaColumns.reduce((acc: Record<string, any>, col: any) => {
              const key = get(col, 'value');
              if (!key) return acc;
              acc[key] = get(source, key);
              return acc;
            }, {} as Record<string, any>),
          ];
        }

        return [source];
      }

      return [];
    }

    if (scanResultType === 'array') {
      return Array.isArray(rawResult) ? rawResult : [];
    }

    if (Array.isArray(rawResult)) {
      return rawResult;
    }

    return flattenData(rawResult)
      .filter((tag: any) => !!tag?.type && tag?.datatype !== 'Unsupported')
      .map((tag: any) => {
        const next = { ...tag };
        delete next.children;
        return next;
      });
  };

  const remapValidationRowsByRetainedIndexes = (rows: any[], retainedAssetIndexes: number[]) => {
    const indexMap = new Map<number, number>();
    retainedAssetIndexes.forEach((oldIndex, newIndex) => {
      indexMap.set(Number(oldIndex), newIndex);
    });

    return (rows || [])
      .filter((row) => indexMap.has(Number(row?.asset_index)))
      .map((row) => ({
        ...row,
        asset_index: indexMap.get(Number(row?.asset_index)),
      }));
  };

  const validSecretRefs = useMemo(() => {
    const ids = new Set<string>();
    const names = new Set<string>();
    (secretsData || []).forEach((secret: any) => {
      const id = get(secret, 'secret_id');
      const name = String(get(secret, 'secret_name', '')).trim().toLowerCase();
      if (id !== undefined && id !== null) ids.add(String(id));
      if (name) names.add(name);
    });
    return { ids, names };
  }, [secretsData]);

  const isKnownSecretValue = useCallback(
    (value: any) => {
      const raw = String(value ?? '').trim();
      if (!raw) return false;
      const idMatch = raw.match(/^secret:(\d+)$/i);
      return idMatch ? validSecretRefs.ids.has(idMatch[1]) : validSecretRefs.names.has(raw.toLowerCase());
    },
    [validSecretRefs]
  );

  const runImportComponentScan = useCallback(
    async ({
      gatewayId,
      asset,
      component,
      onStarted,
      registerCancel,
    }: {
      gatewayId: string;
      asset: any;
      component: any;
      assetIndex: number;
      componentIndex: number;
      onStarted?: () => void;
      registerCancel?: (cancelFn: () => void) => void;
    }): Promise<{ status: 'success' | 'warning' | 'failed' }> => {
      try {
        const normalizeRootTagArray = (value: any): string[] => {
          if (Array.isArray(value)) {
            return value.map((item) => String(item ?? '').trim()).filter(Boolean);
          }

          if (typeof value === 'string') {
            const trimmed = value.trim();
            if (!trimmed) return [];

            if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
              try {
                const parsed = JSON.parse(trimmed);
                if (Array.isArray(parsed)) {
                  return parsed.map((item) => String(item ?? '').trim()).filter(Boolean);
                }
              } catch {
                // fall through to delimiter-based parsing
              }
            }

            const parts = trimmed
              .split(/\r?\n|,/)
              .map((item) => item.trim())
              .filter(Boolean);

            return parts.length > 0 ? parts : [trimmed];
          }

          if (value === null || value === undefined) return [];

          return [String(value).trim()].filter(Boolean);
        };

        const normalizeName = (value: any) => String(value ?? '').trim().toLowerCase();
        const componentName = String(get(component, 'component_name', get(component, 'label', ''))).trim();
        const matchedComponent = (components || []).find(
          (c: any) => normalizeName(get(c, 'component_name', '')) === normalizeName(componentName)
        );

        const backendSchema =
          safeParseSchema(get(component, 'backend_schema')) || safeParseSchema(get(matchedComponent, 'backend_schema')) || {};

        const serviceId =
          get(component, 'service_id') || get(matchedComponent, 'service_id') || get(matchedComponent, 'data.service_id');

        const service = (services || []).find(
          (svc: any) =>
            String(get(svc, 'service_id', '')) === String(serviceId ?? '') ||
            String(get(svc, 'id', '')) === String(serviceId ?? '')
        );

        const servicePort = get(service, 'port');
        const assetIp = String(get(asset, 'data.ip', '')).trim();
        const commandId =
          String(get(component, 'uuid', '')).trim() ||
          `asset:import:${String(get(component, 'component_id', get(component, 'id', 'na')))}:${uuidv4()}`;

        if (!component.uuid) {
          component.uuid = commandId;
        }

        registerCancel?.(() => cancelImportScanCommandWaiter(commandId));

        if (!servicePort || !assetIp) {
          return { status: 'failed' };
        }

        const schemaProperties = get(backendSchema, 'properties', {});
        const secretKeys = Object.keys(schemaProperties || {})
          .map((key: any) => ({
            ...schemaProperties[key],
            secret_key: key,
          }))
          .filter((prop: any) => Boolean(prop?.secret));

        const selectedSecrets = secretKeys.reduce((acc: any, key: any) => {
          const value = get(component, ['data', key.secret_key], '');
          // Secrets not present in secretsData are dropped so the scan payload never carries them.
          if (!isKnownSecretValue(value)) return acc;
          return { ...acc, [key.secret_key]: value };
        }, {});

        const hasSelectedSecrets = Object.keys(selectedSecrets).length > 0;

        const componentDataRaw = (get(component, 'data', {}) || {}) as Record<string, any>;
        const normalizedScanRoot = normalizeRootTagArray(componentDataRaw.scan_root);
        const normalizedRootTags = normalizeRootTagArray(componentDataRaw.root_tags);
        const mergedRootTags = normalizedRootTags.length > 0 ? normalizedRootTags : normalizedScanRoot;
        const { scan_root: _omitScanRoot, ...componentDataWithoutScanRoot } = componentDataRaw;
        const componentData = {
          ...componentDataWithoutScanRoot,
          ...(mergedRootTags.length > 0 ? { root_tags: mergedRootTags } : {}),
        };

        // Schema secret fields with unknown values must not reach the rendered payload.
        secretKeys.forEach((key: any) => {
          if (!isKnownSecretValue((componentData as any)[key.secret_key])) {
            delete (componentData as any)[key.secret_key];
          }
        });

        const payloadData = {
          command_id: commandId,
          args: [],
          url: `${assetIp}:${servicePort}`,
          ...componentData,
        };

        const payloadTemplate = get(backendSchema, 'payload', {
          name: 'scan',
          params: {
            args: '{{args}}',
            kwargs: {
              password: '{{password}}',
              tls_algo: '{{tls_algo}}',
              username: '{{username}}',
              root_tags: '{{root_tags}}',
              server_url: 'opc.tcp://{{url}}',
              certificate: '{{certificate}}',
              private_key: '{{privateKey}}',
            },
            scan_type: 'OPC',
          },
          command_id: '{{command_id}}',
        });

        const renderedPayload = renderScanPayloadTemplate(payloadTemplate, payloadData);
        const renderedKwargs = get(renderedPayload, 'params.kwargs', {});
        if (renderedKwargs && typeof renderedKwargs === 'object') {
          const existingRootTags = renderedKwargs.root_tags;
          const existingScanRoot = renderedKwargs.scan_root;
          const normalizedRootTags = get(componentData, 'root_tags');
          const hasNormalizedRootTags = Array.isArray(normalizedRootTags)
            ? normalizedRootTags.length > 0
            : normalizedRootTags !== undefined && normalizedRootTags !== null && String(normalizedRootTags).trim() !== '';
          const isRootTagsMissing =
            existingRootTags === undefined ||
            existingRootTags === null ||
            existingRootTags === '' ||
            (Array.isArray(existingRootTags) && existingRootTags.length === 0);

          if (
            isRootTagsMissing &&
            hasNormalizedRootTags
          ) {
            renderedKwargs.root_tags = normalizedRootTags;
          }

          if (
            (renderedKwargs.root_tags === undefined ||
              renderedKwargs.root_tags === null ||
              renderedKwargs.root_tags === '' ||
              (Array.isArray(renderedKwargs.root_tags) && renderedKwargs.root_tags.length === 0)) &&
            existingScanRoot !== undefined &&
            existingScanRoot !== null &&
            existingScanRoot !== ''
          ) {
            renderedKwargs.root_tags = existingScanRoot;
          }
          if (Object.prototype.hasOwnProperty.call(renderedKwargs, 'scan_root')) {
            delete renderedKwargs.scan_root;
          }
        }

        const messagePayload = {
          ...renderedPayload,
          ...(hasSelectedSecrets ? selectedSecrets : {}),
        };

        const requestPayload = {
          factory_id: Number(rowId),
          gateway_id: gatewayId,
          topic: `local/${gatewayId}/core/commands`,
          component_id: get(component, 'id', get(matchedComponent, 'id', componentName)),
          message: messagePayload,
        };

        const commandResponsePromise = waitForImportScanCommandResponse(commandId, gatewayId, onStarted);

        const startResponse = await FactoryManagementService.scanTagsApiCall(requestPayload);
        if (startResponse.status !== 'success') {
          importScanCommandWaitersRef.current.delete(commandId);
          return { status: 'failed' };
        }

        const waitResult = await commandResponsePromise;

        const commandResponse = waitResult.message || {};
        const errorRaw = String(getImportScanCommandField(commandResponse, 'error') ?? '').trim();
        const errorNormalized = errorRaw.toLowerCase();
        const errorMessage = ['', 'none', 'null', 'nil', 'no error', 'ok', 'success'].includes(errorNormalized)
          ? ''
          : errorRaw;

        if (errorMessage) {
          return { status: 'failed' };
        }

        const responseResultRaw = parseScanCommandResult(getImportScanCommandField(commandResponse, 'result'));
        const responseResultText = getScanLifecycleText(responseResultRaw);
        if (responseResultText === 'stopped' || responseResultText === 'failed' || responseResultText === 'error') {
          return { status: 'failed' };
        }

        if (hasImportScanFailureSignal(responseResultRaw)) {
          return { status: 'failed' };
        }

        const scanPayloadRaw = parseScanCommandResult(getImportScanCommandField(commandResponse, 'scan'));
        const normalizedResultLifecycle = normalizeScanLifecycleText(responseResultRaw);
        const responseResultForNormalization =
          (responseResultRaw !== undefined && responseResultRaw !== null && typeof responseResultRaw !== 'string')
            ? responseResultRaw
            : scanPayloadRaw !== undefined
              ? { scan: scanPayloadRaw }
              : (normalizedResultLifecycle === 'success' || normalizedResultLifecycle === 'completed')
                ? {}
                : responseResultRaw;

        if (responseResultForNormalization !== undefined) {
          const normalizedScanResult = normalizeImportScanResult(
            responseResultForNormalization,
            get(backendSchema, 'scanResult', {})
          );

          // Treat empty/invalid scan output as warning to avoid false "Completed" status in bulk scan UI.
          if (!Array.isArray(normalizedScanResult) || normalizedScanResult.length === 0) {
            component.data = {
              ...(component.data || {}),
              scan_result: [],
            };
            component.operation = component.operation || 'edited';
            return { status: 'warning' };
          }

          component.data = {
            ...(component.data || {}),
            scan_result: normalizedScanResult,
          };
          component.operation = component.operation || 'edited';
        }

        return { status: 'success' };
      } catch {
        return { status: 'failed' };
      }
    },
    [cancelImportScanCommandWaiter, components, isKnownSecretValue, rowId, services, waitForImportScanCommandResponse]
  );

  const componentSchemaMapMemo = useMemo(() => {
    const map: Record<string, { ui_schema?: any; backend_schema?: any }> = {};
    (components || []).forEach((c: any) => {
      const name = String(get(c, 'component_name', '')).trim().toLowerCase();
      if (!name) return;
      map[name] = {
        ui_schema: safeParseSchema(get(c, 'ui_schema')),
        backend_schema: safeParseSchema(get(c, 'backend_schema')),
      };
    });
    return map;
  }, [components]);

  const toTitleFromKey = (key: string) =>
    key
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');

  const getComponentSecretFieldsByName = () => {
    const map = new Map<string, Array<{ key: string; label: string; isDropdown: boolean; options: string[] }>>();

    const normalizeOptionList = (input: any): string[] => {
      if (!input) return [];
      if (Array.isArray(input)) {
        return input
          .map((item: any) => {
            if (item === null || item === undefined) return '';
            if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
              return String(item);
            }
            if (typeof item === 'object') {
              return String(item.value ?? item.const ?? item.id ?? item.key ?? item.label ?? item.title ?? item.name ?? '');
            }
            return '';
          })
          .map((v: string) => v.trim())
          .filter(Boolean);
      }

      if (typeof input === 'object') {
        return normalizeOptionList(
          input.enumOptions ??
          input.values ??
          input.enums ??
          input.enum ??
          input.oneOf ??
          input.items ??
          input.options
        );
      }

      return [];
    };

    const secretApiOptions = Array.from(
      new Set(
        (secretsData || [])
          .map((secret: any) => String(get(secret, 'secret_name', '')).trim())
          .filter(Boolean)
      )
    );

    (components || []).forEach((component: any) => {
      const componentName = String(get(component, 'component_name', '')).trim();
      const componentKey = componentName.toLowerCase();
      if (!componentKey) return;

      const uiSchema = safeParseSchema(get(component, 'ui_schema'));
      const backendSchema = safeParseSchema(get(component, 'backend_schema'));
      const uiLabelByKey: Record<string, string> = {};
      const uiOptionsByKey: Record<string, string[]> = {};

      const properties = get(backendSchema, 'properties', {});

      // Collect all UI controls (flatten nested layouts)
      const collectControls = (elements: any[]): any[] => {
        const result: any[] = [];
        (Array.isArray(elements) ? elements : []).forEach((el: any) => {
          if (!el || typeof el !== 'object') return;
          if (el.type === 'Control') {
            result.push(el);
          } else if (Array.isArray(el.elements)) {
            result.push(...collectControls(el.elements));
          } else if (el.options?.detail?.elements) {
            result.push(...collectControls(el.options.detail.elements));
          }
        });
        return result;
      };

      const uiElements = Array.isArray(uiSchema?.elements) ? uiSchema.elements : [];
      collectControls(uiElements).forEach((el: any) => {
        const scope = String(get(el, 'scope', '')).trim();
        const key = scope.split('/').pop();
        if (!key) return;
        const label = String(get(el, 'label', '')).trim();
        if (label) uiLabelByKey[key] = label;
        uiOptionsByKey[key] = normalizeOptionList(get(el, 'options', []));
      });

      // Only include fields that have a UI control AND are marked secret in backend schema.
      // This avoids showing backend-only secret fields that users cannot see or fill.
      const fields = Object.keys(uiLabelByKey)
        .filter((fieldKey) => get(properties[fieldKey], 'secret') === true)
        .map((fieldKey) => {
          const uiOptions = uiOptionsByKey[fieldKey] || [];
          const schemaEnumOptions = normalizeOptionList(get(properties[fieldKey], 'enum', []));
          const options = Array.from(new Set([...uiOptions, ...schemaEnumOptions, ...secretApiOptions]));

          return {
            key: fieldKey,
            label: uiLabelByKey[fieldKey] || toTitleFromKey(fieldKey),
            isDropdown: true,
            options,
          };
        });

      map.set(componentKey, fields);
    });

    return map;
  };

  const getComponentRequiredSecretsByName = () => {
    const map = new Map<string, string[]>();

    (components || []).forEach((component: any) => {
      const componentName = String(get(component, 'component_name', '')).trim().toLowerCase();
      if (!componentName) return;

      const backendSchema = safeParseSchema(get(component, 'backend_schema'));
      const requiredSecretsRaw = get(backendSchema, 'required_secrets', []);
      const requiredSecrets = Array.isArray(requiredSecretsRaw)
        ? requiredSecretsRaw.map((k: any) => String(k).trim()).filter(Boolean)
        : [];

      map.set(componentName, requiredSecrets);
    });

    return map;
  };

  const buildImportValidation = (importedAssets: any[], selectedGatewayId: string | null) => {
    const isNonEmpty = (value: any) => String(value ?? '').trim().length > 0;
    const componentSecretFieldsByName = getComponentSecretFieldsByName();
    const knownSecretFieldKeys = new Set(
      Array.from(componentSecretFieldsByName.values())
        .flatMap((fields) => fields.map((field) => String(field.key || '').trim()))
        .filter(Boolean)
    );
    const validComponentNames = new Set(
      (components || [])
        .map((component: any) => String(get(component, 'component_name', '')).trim().toLowerCase())
        .filter(Boolean)
    );

    const effectiveNodes = getEffectiveConfigNodes();

    const existingAssetsForGateway = selectedGatewayId
      ? getGatewayScopedAssetNodes(effectiveNodes, String(selectedGatewayId))
      : [];

    const existingAssetCandidates = existingAssetsForGateway.map((asset: any) => ({
      id: asset.id,
      name: get(asset, 'data.name', ''),
      ip: get(asset, 'data.ip', ''),
      enabled: get(asset, 'data.enabled', true),
      source: 'existing',
    }));

    const importedAssetCandidates = importedAssets.map((asset: any, idx: number) => ({
      id: `imported-${idx}`,
      name: get(asset, 'data.name', ''),
      ip: get(asset, 'data.ip', ''),
      enabled: get(asset, 'data.enabled', true),
      source: 'imported',
      index: idx,
    }));

    const validationRows: any[] = [];
    const validationErrors: string[] = [];
    const validationWarnings: string[] = [];

    importedAssets.forEach((asset: any, assetIndex: number) => {
      const assetName = String(get(asset, 'data.name', '')).trim();
      const assetIp = String(get(asset, 'data.ip', '')).trim();
      const options = get(asset, 'data.options', []) as any[];

      const assetLevelErrors: string[] = [];

      if (!isNonEmpty(assetName)) {
        assetLevelErrors.push('Asset name is required.');
      }
      if (!isNonEmpty(assetIp)) {
        assetLevelErrors.push('Asset IP is required.');
      }

      const thisImportedCandidate = importedAssetCandidates[assetIndex];
      const duplicateWithExisting = existingAssetCandidates.some((candidate: any) =>
        isDuplicateAssetIdentity(thisImportedCandidate, candidate)
      );
      const duplicateWithinImport = importedAssetCandidates.some(
        (candidate: any, idx: number) => idx !== assetIndex && isDuplicateAssetIdentity(thisImportedCandidate, candidate)
      );

      if (duplicateWithExisting) {
        assetLevelErrors.push('Asset already exists in gateway.');
      }
      if (duplicateWithinImport) {
        assetLevelErrors.push('Duplicate asset in import.');
      }

      const existingMatchedAsset = existingAssetsForGateway.find((existing: any) =>
        isDuplicateAssetIdentity(thisImportedCandidate, {
          id: existing.id,
          name: get(existing, 'data.name', ''),
          ip: get(existing, 'data.ip', ''),
          enabled: get(existing, 'data.enabled', true),
        })
      );

      const existingComponentNames = new Set<string>(
        (get(existingMatchedAsset, 'data.options', []) as any[])
          .map((c: any) => String(get(c, 'component_name', '')).trim().toLowerCase())
          .filter(Boolean)
      );

      const seenImportComponentNames = new Set<string>();

      if (!options.length) {
        const combined = [...assetLevelErrors];
        validationRows.push({
          id: `asset-${assetIndex}`,
          asset_index: assetIndex,
          component_index: -1,
          asset_name: assetName,
          asset_ip: assetIp,
          asset_status: get(asset, 'data.enabled', true) ? 'Enable' : 'Disable',
          component_name: '',
          component_status: '',
          secrets: {},
          messages_count: 0,
          params_count: 0,
          status: combined.length ? 'Error' : 'Valid',
          issues: combined.join(' | '),
        });
        validationErrors.push(...combined);
        return;
      }

      options.forEach((component: any, componentIndex: number) => {
        const componentName = String(get(component, 'component_name', get(component, 'label', ''))).trim();
        const componentNameKey = String(componentName).trim().toLowerCase();
        const componentData = get(component, 'data', {});
        const secretFields = componentSecretFieldsByName.get(componentNameKey) || [];
        const rowSecrets: Record<string, string> = {};
        secretFields.forEach((field) => {
          rowSecrets[field.key] = String(get(componentData, field.key, '')).trim();
        });
        Object.keys(componentData || {}).forEach((dataKey) => {
          const key = String(dataKey || '').trim();
          if (!key) return;
          if (!/^secret_/i.test(key) && !knownSecretFieldKeys.has(key)) return;
          const value = String(get(componentData, key, '')).trim();
          if (!value) return;
          if (!Object.prototype.hasOwnProperty.call(rowSecrets, key)) {
            rowSecrets[key] = value;
          }
        });
        const messages = Array.isArray(componentData?.messages) ? componentData.messages : [];
        const paramsCount = messages.reduce((acc: number, m: any) => {
          const props = Array.isArray(m?.props) ? m.props.length : 0;
          return acc + props;
        }, 0);

        const rowErrors = [...assetLevelErrors];

        if (!isNonEmpty(componentName)) {
          rowErrors.push('Component name is required.');
        }

        if (componentNameKey) {
          if (seenImportComponentNames.has(componentNameKey)) {
            rowErrors.push(`Duplicate component: "${componentName}".`);
          }
          seenImportComponentNames.add(componentNameKey);

          if (!validComponentNames.has(componentNameKey)) {
            rowErrors.push(`Invalid component: "${componentName}".`);
          }

          if (existingComponentNames.has(componentNameKey)) {
            rowErrors.push('Component already exists.');
          }
        }

        validationRows.push({
          id: `asset-${assetIndex}-component-${componentIndex}`,
          asset_index: assetIndex,
          component_index: componentIndex,
          asset_name: assetName,
          asset_ip: assetIp,
          asset_status: get(asset, 'data.enabled', true) ? 'Enable' : 'Disable',
          component_name: componentName,
          component_status: get(component, 'enabled', true) ? 'Enable' : 'Disable',
          secrets: rowSecrets,
          messages_count: messages.length,
          params_count: paramsCount,
          status: rowErrors.length ? 'Error' : 'Valid',
          issues: rowErrors.join(' | '),
        });

        validationErrors.push(...rowErrors);
      });
    });

    return {
      validationRows,
      validationErrors: Array.from(new Set(validationErrors.filter(Boolean))),
      validationWarnings: Array.from(new Set(validationWarnings.filter(Boolean))),
    };
  };

  const applyValidationRowsToAssets = (sourceAssets: any[], rows: any[]) => {
    const statusToEnabled = (statusRaw: any) => {
      const normalized = String(statusRaw ?? '').trim().toLowerCase();
      if (!normalized) return true;
      if (['inactive', 'disable', 'disabled', 'false', '0', 'no', 'off'].includes(normalized)) return false;
      if (['active', 'enable', 'enabled', 'true', '1', 'yes', 'on'].includes(normalized)) return true;
      return true;
    };

    // Build a lookup: secret_name (lowercase) → "secret:<id>" form value expected by JsonForms
    const secretNameToFormValue = new Map<string, string>();
    (secretsData || []).forEach((secret: any) => {
      const name = String(get(secret, 'secret_name', '')).trim();
      const id = get(secret, 'secret_id');
      if (name && id !== undefined && id !== null) {
        secretNameToFormValue.set(name.toLowerCase(), `secret:${id}`);
      }
    });

    const resolveSecretValue = (rawValue: string): string => {
      if (!rawValue) return rawValue;
      // Already in canonical form (secret:123) — keep as-is
      if (/^secret:\d+$/i.test(rawValue)) return rawValue;
      // Try to map secret_name → secret:<id>
      const mapped = secretNameToFormValue.get(rawValue.toLowerCase());
      return mapped ?? rawValue;
    };

    const assets = JSON.parse(JSON.stringify(sourceAssets || []));
    const componentSecretFieldsByName = getComponentSecretFieldsByName();
    const rowMap = new Map<string, any>();
    rows.forEach((row) => {
      rowMap.set(`${row.asset_index}::${row.component_index}`, row);
    });

    const nextAssets: any[] = [];

    assets.forEach((asset: any, assetIndex: number) => {
      const assetRows = rows.filter((r) => r.asset_index === assetIndex);
      if (!assetRows.length) return;
      const hasAssetLevelRow = assetRows.some((row) => row.component_index === -1);

      const primaryRow = assetRows[0];
      asset.data = asset.data || {};
      asset.data.name = primaryRow.asset_name ?? asset.data.name;
      asset.data.ip = primaryRow.asset_ip ?? asset.data.ip;
      asset.data.enabled = statusToEnabled(primaryRow.asset_status);

      const existingOptions = Array.isArray(asset.data.options) ? asset.data.options : [];
      const nextOptions: any[] = [];

      existingOptions.forEach((option: any, componentIndex: number) => {
        const row = rowMap.get(`${assetIndex}::${componentIndex}`);
        if (!row) return; // deleted in popup

        option.component_name = row.component_name ?? option.component_name;
        option.label = option.component_name;
        option.enabled = statusToEnabled(row.component_status);
        option.data = option.data || {};

        const componentKey = String(option.component_name || '').trim().toLowerCase();
        const secretFields = componentSecretFieldsByName.get(componentKey) || [];
        const allowedSecretKeys = new Set(secretFields.map((field) => field.key));

        Object.keys(option.data).forEach((fieldKey) => {
          if (/^secret_/i.test(fieldKey) && !allowedSecretKeys.has(fieldKey)) {
            delete option.data[fieldKey];
          }
        });

        const rowSecrets = get(row, 'secrets', {}) || {};
        secretFields.forEach((field) => {
          if (Object.prototype.hasOwnProperty.call(rowSecrets, field.key)) {
            option.data[field.key] = resolveSecretValue(String(rowSecrets[field.key] ?? ''));
          } else if (!Object.prototype.hasOwnProperty.call(option.data, field.key)) {
            option.data[field.key] = '';
          }
        });

        nextOptions.push(option);
      });

      asset.data.options = nextOptions;

      // Keep asset-only imports instead of dropping them during save.
      if (asset.data.options.length > 0 || hasAssetLevelRow) {
        nextAssets.push(asset);
      }
    });

    return nextAssets;
  };

  function deriveModifiedScanPlan(assets: any[], selectedGatewayId: string | null) {
    const normalizedGatewayId = String(selectedGatewayId ?? '').trim();
    const nextAssets = JSON.parse(JSON.stringify(assets || []));
    const scanAssetIndexes = new Set<number>();

    if (!normalizedGatewayId) {
      return {
        assets: nextAssets,
        scanAssetIndexes: nextAssets.map((_: any, idx: number) => idx),
      };
    }

    const effectiveNodes = getEffectiveConfigNodes();
    const existingAssets = getGatewayScopedAssetNodes(effectiveNodes, normalizedGatewayId);

    const getScanValidateFields = (componentName: string) => {
      const schemaEntry = componentSchemaMapMemo[String(componentName ?? '').trim().toLowerCase()] || {};
      const parsedBackendSchema = safeParseSchema(get(schemaEntry, 'backend_schema')) || {};
      const messageProperties: Record<string, any> = get(
        parsedBackendSchema,
        'properties.messages.items.properties',
        {}
      );
      const paramProperties: Record<string, any> = get(messageProperties, 'props.items.properties', {});

      const messageFields = Object.keys(messageProperties).filter(
        (field) => field !== 'props' && get(messageProperties[field], 'x-scanValidate') === true
      );
      const paramFields = Object.keys(paramProperties).filter(
        (field) => get(paramProperties[field], 'x-scanValidate') === true
      );

      return {
        messageFields: messageFields.length > 0 ? messageFields : ['trigger'],
        paramFields: paramFields.length > 0 ? paramFields : ['id'],
      };
    };

    const collectComparableValues = (component: any, fields: { messageFields: string[]; paramFields: string[] }) => {
      const values = new Set<string>();
      const messages = Array.isArray(get(component, 'data.messages')) ? get(component, 'data.messages') : [];

      messages.forEach((message: any) => {
        fields.messageFields.forEach((field) => {
          const value = String(get(message, field, '') ?? '').trim().toLowerCase();
          if (value) values.add(value);
        });

        const props = Array.isArray(get(message, 'props')) ? get(message, 'props') : [];
        props.forEach((prop: any) => {
          fields.paramFields.forEach((field) => {
            const value = String(get(prop, field, '') ?? '').trim().toLowerCase();
            if (value) values.add(value);
          });
        });
      });

      return values;
    };

    nextAssets.forEach((asset: any, assetIndex: number) => {
      const matchedExistingAsset = existingAssets.find((existingAsset: any) =>
        isDuplicateAssetIdentity(asset, existingAsset)
      );

      if (!matchedExistingAsset) {
        scanAssetIndexes.add(assetIndex);
        return;
      }

      const existingAssetId = String(get(matchedExistingAsset, 'id', '')).trim();
      const existingOptions = getModifiedScanExistingOptions(
        existingAssetId,
        Array.isArray(get(matchedExistingAsset, 'data.options')) ? get(matchedExistingAsset, 'data.options') : []
      );
      const existingOptionsByName = new Map<string, any>();

      (existingOptions || []).forEach((option: any) => {
        const key = String(get(option, 'component_name', get(option, 'label', ''))).trim().toLowerCase();
        if (key) existingOptionsByName.set(key, option);
      });

      const importedOptions = Array.isArray(get(asset, 'data.options')) ? get(asset, 'data.options') : [];
      let shouldScan = false;

      importedOptions.forEach((importedOption: any, componentIndex: number) => {
        if (shouldScan) return;

        const componentName = String(get(importedOption, 'component_name', get(importedOption, 'label', ''))).trim();
        const componentKey = componentName.toLowerCase();
        if (!componentKey) return;

        const existingOption = existingOptionsByName.get(componentKey);
        if (!existingOption) {
          shouldScan = true;
          return;
        }

        const existingScanResult = get(existingOption, 'data.scan_result', []);
        const scannedTagKeys = extractScannedTagKeys(existingScanResult);
        if (scannedTagKeys.size === 0) {
          shouldScan = true;
          return;
        }

        const comparableValues = collectComparableValues(importedOption, getScanValidateFields(componentName));
        if (comparableValues.size === 0) {
          nextAssets[assetIndex].data.options[componentIndex] = {
            ...nextAssets[assetIndex].data.options[componentIndex],
            data: {
              ...(get(nextAssets[assetIndex], `data.options[${componentIndex}].data`, {}) || {}),
              scan_result: JSON.parse(JSON.stringify(existingScanResult)),
            },
          };
          return;
        }

        const allValuesPresent = Array.from(comparableValues).every((value) => scannedTagKeys.has(value));
        if (!allValuesPresent) {
          shouldScan = true;
          return;
        }

        nextAssets[assetIndex].data.options[componentIndex] = {
          ...nextAssets[assetIndex].data.options[componentIndex],
          data: {
            ...(get(nextAssets[assetIndex], `data.options[${componentIndex}].data`, {}) || {}),
            scan_result: JSON.parse(JSON.stringify(existingScanResult)),
          },
        };
      });

      if (shouldScan) {
        scanAssetIndexes.add(assetIndex);
      }
    });

    return {
      assets: nextAssets,
      scanAssetIndexes: Array.from(scanAssetIndexes).filter((idx) => Number.isFinite(idx) && idx >= 0),
    };
  }

  function collectMissingModifiedScanAssetIds(assets: any[], selectedGatewayId: string | null): string[] {
    const normalizedGatewayId = String(selectedGatewayId ?? '').trim();
    if (!normalizedGatewayId) return [];

    const effectiveNodes = getEffectiveConfigNodes();
    const existingAssets = getGatewayScopedAssetNodes(effectiveNodes, normalizedGatewayId);
    const missingAssetIds = new Set<string>();

    (assets || []).forEach((asset: any) => {
      const matchedExistingAsset = existingAssets.find((existingAsset: any) =>
        isDuplicateAssetIdentity(asset, existingAsset)
      );
      if (!matchedExistingAsset) return;

      const existingAssetId = String(get(matchedExistingAsset, 'id', '')).trim();
      if (!existingAssetId) return;

      const importedOptions = Array.isArray(get(asset, 'data.options')) ? get(asset, 'data.options') : [];
      if (importedOptions.length === 0) return;

      const existingOptions = getModifiedScanExistingOptions(
        existingAssetId,
        Array.isArray(get(matchedExistingAsset, 'data.options')) ? get(matchedExistingAsset, 'data.options') : []
      );

      // Existing options not available at all -> fetch from API.
      if ((existingOptions || []).length === 0) {
        missingAssetIds.add(existingAssetId);
        return;
      }

      const existingOptionsByName = new Map<string, any>();
      (existingOptions || []).forEach((option: any) => {
        const key = String(get(option, 'component_name', get(option, 'label', ''))).trim().toLowerCase();
        if (key) existingOptionsByName.set(key, option);
      });

      // If matched component exists but scan_result is missing/empty/unusable -> fetch from API.
      const hasMissingScanResultOnMatchedComponent = importedOptions.some((importedOption: any) => {
        const componentKey = String(
          get(importedOption, 'component_name', get(importedOption, 'label', ''))
        )
          .trim()
          .toLowerCase();

        if (!componentKey) return false;

        const existingOption = existingOptionsByName.get(componentKey);
        if (!existingOption) return false; // no existing component match => handled by scan decision path

        const existingScanResult = get(existingOption, 'data.scan_result', []);
        const scannedTagKeys = extractScannedTagKeys(existingScanResult);
        return scannedTagKeys.size === 0;
      });

      if (hasMissingScanResultOnMatchedComponent) {
        missingAssetIds.add(existingAssetId);
      }
    });

    return Array.from(missingAssetIds);
  }

  useEffect(() => {
    if (isUpdateUseCaseSuccess) {
      // SuccessSnackBar('Use Case updated successfully.');
      // dispatch(buildUseCaseActions.getUseCaseDataRequest(useCaseId));
      onDataRequest();
      dispatch(gatewayMasterActions.getGatewayDataRequest());
      dispatch(machineryManagementActions.getMachineryManagementDataRequest());
      dispatch(componentMasterActions.getServicesDataRequest());
      dispatch(platformServicesMasterActions.getServicesDataRequest());
    }
  }, [isUpdateUseCaseSuccess]);

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const applyImportedAssetsToConfig = (
    assetsToImport: any[],
    selectedGatewayId: string,
    selectedGatewayData?: any,
    removeExistingAssetNodeIds: string[] = [],
    updateExistingAssets: Array<{ nodeId: string; options: any[]; data?: any }> = []
  ) => {
    try {
      const createImportedComponentId = () => uuidv4();
      const createImportedComponentUuid = (componentId: any) =>
        `asset:import:${String(componentId ?? 'na')}:${uuidv4()}`;

      const normalizeComponentName = (name: any) => String(name ?? '').trim().toLowerCase();
      const componentByName: Map<string, any> = new Map(
        components.map((component: any) => [normalizeComponentName(component.component_name), component] as [string, any])
      );
      let syntheticComponentId = -1;

      const normalizeImportedMessages = (
        messages: any[],
        messagePropertiesSchema: Record<string, any> = {},
        propPropertiesSchema: Record<string, any> = {}
      ) => {
        if (!Array.isArray(messages)) return messages;
        return messages.map((message: any) => {
          const trimStringValue = (value: any) => (typeof value === 'string' ? value.trim() : value);

          const coerceBySchemaType = (rawValue: any, fieldSchema: any) => {
            const schemaTypeRaw = get(fieldSchema, 'type');
            const schemaType = Array.isArray(schemaTypeRaw)
              ? schemaTypeRaw.find((t: any) => t && t !== 'null')
              : schemaTypeRaw;

            if (rawValue === undefined || rawValue === null) return undefined;

            if (schemaType === 'number' || schemaType === 'integer') {
              if (typeof rawValue === 'number' && Number.isFinite(rawValue)) return rawValue;
              const rawText = String(rawValue).trim();
              if (!rawText) return undefined;
              const parsed = Number(rawText);
              if (!Number.isFinite(parsed)) return undefined;
              if (schemaType === 'integer' && !Number.isInteger(parsed)) return undefined;
              return parsed;
            }

            if (schemaType === 'boolean') {
              if (typeof rawValue === 'boolean') return rawValue;
              const normalized = String(rawValue).trim().toLowerCase();
              if (!normalized) return undefined;
              if (normalized === 'true' || normalized === '1') return true;
              if (normalized === 'false' || normalized === '0') return false;
              return undefined;
            }

            if (schemaType === 'string') {
              return trimStringValue(String(rawValue));
            }

            return trimStringValue(rawValue);
          };

          const messageType = String(get(message, 'type', '')).toLowerCase();

          const normalizedProps = Array.isArray(message?.props)
            ? message.props
              .map((prop: any) => {
                // Schema-driven core fields; fallback for schemas without properties.
                const coreFields = Object.keys(propPropertiesSchema).length > 0
                  ? Object.keys(propPropertiesSchema)
                  : ['id', 'key', 'uom'];

                // Drop fully empty parameter entries; keep partial ones for warning-only flow.
                const hasAnyValue = coreFields.some((fieldKey) => {
                  const val = prop[fieldKey];
                  return val !== undefined && val !== null && String(val).trim() !== '';
                });
                if (!hasAnyValue) return null;

                // Place schema-defined fields first (trimmed), then any extra fields.
                const nextProp: Record<string, any> = {};
                coreFields.forEach((fieldKey) => {
                  const val = prop[fieldKey];
                  if (val !== undefined && val !== null) {
                    nextProp[fieldKey] = typeof val === 'string' ? val.trim() : val;
                  }
                });
                Object.keys(prop).forEach((fieldKey) => {
                  if (!(fieldKey in nextProp)) nextProp[fieldKey] = prop[fieldKey];
                });

                Object.keys(nextProp).forEach((fieldKey) => {
                  const coercedValue = coerceBySchemaType(nextProp[fieldKey], propPropertiesSchema[fieldKey]);
                  if (coercedValue === undefined) {
                    delete nextProp[fieldKey];
                  } else {
                    nextProp[fieldKey] = coercedValue;
                  }
                });

                return nextProp;
              })
              .filter(Boolean)
            : [];

          const normalizedMessage: Record<string, any> = {
            ...message,
            id: String(get(message, 'id', '')).trim(),
            name: String(get(message, 'name', '')).trim(),
            type: messageType,
            props: normalizedProps,
          };

          Object.keys(messagePropertiesSchema || {}).forEach((fieldKey) => {
            if (fieldKey === 'props') return;
            if (fieldKey === 'type') {
              normalizedMessage.type = messageType;
              return;
            }

            const coercedValue = coerceBySchemaType(get(message, fieldKey), messagePropertiesSchema[fieldKey]);
            if (coercedValue === undefined) {
              delete normalizedMessage[fieldKey];
            } else {
              normalizedMessage[fieldKey] = coercedValue;
            }
          });

          // Schema-driven: delete x-periodicOnly fields for non-periodic messages; fallback to refresh_interval.
          const periodicOnlyFields = Object.keys(messagePropertiesSchema).filter(
            (k) => get(messagePropertiesSchema[k], 'x-periodicOnly') === true
          );
          (periodicOnlyFields.length > 0 ? periodicOnlyFields : ['refresh_interval']).forEach((field) => {
            if (messageType !== 'periodic') delete normalizedMessage[field];
          });

          return normalizedMessage;
        });
      };

      const normalizeImportedOption = (opt: any) => {
        const extractOptionData = (option: any = {}) => {
          const cloned = { ...(option || {}) };
          const metaKeys = [
            'id',
            'uuid',
            'service_id',
            'component_id',
            'component_name',
            'label',
            'enabled',
            'operation',
            'backend_schema',
            'ui_schema',
            'description',
            'data',
            '__duplicateResolutionSource',
          ];

          metaKeys.forEach((key) => {
            delete cloned[key];
          });

          const rawData = cloned;
          const nestedData = get(option, 'data');
          if (!nestedData || typeof nestedData !== 'object') {
            return rawData;
          }

          const isMeaningful = (value: any) => {
            if (value === null || value === undefined) return false;
            if (typeof value === 'string') return value.trim() !== '';
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === 'object') return Object.keys(value).length > 0;
            return true;
          };

          const merged = { ...rawData };
          Object.keys(nestedData).forEach((key) => {
            const nestedVal = nestedData[key];
            const rawVal = rawData[key];
            if (key === 'messages') {
              merged[key] = nestedVal;
              return;
            }
            if (isMeaningful(nestedVal) || !isMeaningful(rawVal)) {
              merged[key] = nestedVal;
            }
          });

          return merged;
        };

        const importedName = String(get(opt, 'component_name', get(opt, 'label', ''))).trim();
        const matchedComponent: any = componentByName.get(normalizeComponentName(importedName));
        const backendSchema = matchedComponent ? safeParseSchema(get(matchedComponent, 'backend_schema')) : null;
        const messagePropertiesSchema = get(backendSchema, 'properties.messages.items.properties', {});
        const propPropertiesSchema = get(messagePropertiesSchema, 'props.items.properties', {});
        const nextSyntheticComponentId = syntheticComponentId--;
        const optionData = extractOptionData(opt);
        const normalizedMessages = normalizeImportedMessages(
          get(optionData, 'messages', []),
          messagePropertiesSchema,
          propPropertiesSchema
        );
        // const resolvedComponentId = get(opt, 'component_id', matchedComponent?.component_id ?? nextSyntheticComponentId);
        const resolvedComponentId = opt.component_id ?? matchedComponent?.component_id ?? nextSyntheticComponentId;

        const matchedBackendSchema = matchedComponent ? safeParseSchema(get(matchedComponent, 'backend_schema')) : null;
        const matchedUiSchema = matchedComponent ? safeParseSchema(get(matchedComponent, 'ui_schema')) : null;

        // Coerce string values to arrays for fields the backend schema declares as type:"array"
        const coercedData: Record<string, any> = { ...optionData };
        if (backendSchema) {
          const properties = get(backendSchema, 'properties', {});
          Object.keys(properties).forEach((fieldKey) => {
            const fieldType = get(properties[fieldKey], 'type');
            if (fieldType === 'array' && Object.prototype.hasOwnProperty.call(coercedData, fieldKey)) {
              const val = coercedData[fieldKey];
              if (typeof val === 'string') {
                // Empty string → empty array; non-empty string → single-element array
                coercedData[fieldKey] = val.trim() === '' ? [] : [val.trim()];
              } else if (!Array.isArray(val)) {
                coercedData[fieldKey] = val !== null && val !== undefined ? [val] : [];
              }
            }
          });
        }

        // Try to infer service_id from component master when missing on import
        let deducedServiceId = opt?.service_id ?? matchedComponent?.service_id ?? null;
        if (!deducedServiceId) {
          const byId = components.find((c: any) => String(get(c, 'id')) === String(resolvedComponentId));
          if (byId) {
            deducedServiceId = get(byId, 'data.service_id', get(byId, 'service_id', deducedServiceId));
          }
        }

        return {
          ...opt,
          id: opt?.id ?? createImportedComponentId(),
          uuid: opt?.uuid ?? createImportedComponentUuid(resolvedComponentId),
          service_id: deducedServiceId,
          component_id: resolvedComponentId,
          component_name: matchedComponent?.component_name ?? importedName,
          label: matchedComponent?.component_name ?? importedName,
          backend_schema: safeParseSchema(get(opt, 'backend_schema')) || matchedBackendSchema || backendSchema || {},
          ui_schema: safeParseSchema(get(opt, 'ui_schema')) || matchedUiSchema || {},
          enabled: Boolean(get(opt, 'enabled', true)),
          data: {
            ...coercedData,
            ...(Array.isArray(normalizedMessages) ? { messages: normalizedMessages } : {}),
          },
          operation: 'added',
        };
      };

      const importedAssets = assetsToImport.map((asset: any) => ({
        ...asset,
        id: asset.id,
        type: 'assetNode',
      }));

      const requestedImportCount = importedAssets.length;

      let addedAssetsForStore: Array<{ id: string; options: any[] }> = [];
      let updatedAssetsForStore: Array<{ id: string; options: any[] }> = [];
      let removedAssetNodesToTrack: Node[] = [];

      // Persisted-state lookups used to derive the correct component "operation" status.
      // A component must be marked 'added' when its parent asset (or the component itself)
      // was never saved to the backend, and 'edited' only when it already existed.
      // This prevents a newly-imported (unsaved, operation:'added') asset from receiving
      // 'edited' components on merge — which the backend cannot reconcile, causing the
      // components to disappear after save (Bug 1) and the status to be wrong (Bug 2).
      const persistedAssetNodeIds = new Set([
        // Original loaded config (first page load)
        ...(normalizedSelectedRowUiConfig.nodes || [])
          .filter((persistedNode: any) => persistedNode?.type === 'assetNode')
          .map((persistedNode: any) => String(persistedNode?.id ?? ''))
          .filter(Boolean),
        // Nodes saved in the current session (selectedRow is NOT refreshed by the saga after save,
        // so this ref is the only reliable post-save baseline).
        ...(lastSavedConfigRef.current.nodes || [])
          .filter((persistedNode: any) => persistedNode?.type === 'assetNode')
          .map((persistedNode: any) => String(persistedNode?.id ?? ''))
          .filter(Boolean),
      ]);

      const persistedComponentNamesByAsset = new Map<string, Set<string>>();
      const registerPersistedComponentName = (assetKey: any, rawName: any) => {
        const normalizedAssetKey = String(assetKey ?? '').trim();
        const compName = normalizeComponentName(rawName);
        if (!normalizedAssetKey || !compName) return;
        if (!persistedComponentNamesByAsset.has(normalizedAssetKey)) {
          persistedComponentNamesByAsset.set(normalizedAssetKey, new Set<string>());
        }
        persistedComponentNamesByAsset.get(normalizedAssetKey)!.add(compName);
      };

      (selectedRow?.config?.gateways || []).forEach((persistedGateway: any) => {
        (persistedGateway?.components || []).forEach((persistedComponent: any) => {
          registerPersistedComponentName(
            get(persistedComponent, 'asset_id', ''),
            get(persistedComponent, 'component_name', get(persistedComponent, 'label', ''))
          );
        });
      });

      (normalizedSelectedRowUiConfig.nodes || [])
        .filter((persistedNode: any) => persistedNode?.type === 'assetNode')
        .forEach((persistedNode: any) => {
          const persistedOptions = get(persistedNode, 'data.options', get(persistedNode, 'data.data.options', []));
          (Array.isArray(persistedOptions) ? persistedOptions : []).forEach((persistedOption: any) => {
            registerPersistedComponentName(
              get(persistedNode, 'id', ''),
              get(
                persistedOption,
                'component_name',
                get(persistedOption, 'label', get(persistedOption, 'data.component_name', ''))
              )
            );
          });
        });

      // Also register from the last-saved config so that components saved in the current
      // session (after import+save, where selectedRow is NOT refreshed by the saga) are
      // correctly identified as 'edited' on the next import rather than 'added'.
      (lastSavedConfigRef.current.nodes || [])
        .filter((persistedNode: any) => persistedNode?.type === 'assetNode')
        .forEach((persistedNode: any) => {
          const persistedOptions = get(persistedNode, 'data.options', []);
          (Array.isArray(persistedOptions) ? persistedOptions : []).forEach((persistedOption: any) => {
            registerPersistedComponentName(
              get(persistedNode, 'id', ''),
              get(persistedOption, 'component_name', get(persistedOption, 'label', ''))
            );
          });
        });

      setConfig((prev: any) => {
        const removeSet = new Set(removeExistingAssetNodeIds.map((id) => String(id)));
        const prevNodesRaw: any[] = prev?.nodes ?? [];
        const prevEdgesRaw: any[] = prev?.edges ?? [];

        const updateByNodeId = new Map<string, { nodeId: string; options: any[]; data?: any }>();
        (updateExistingAssets || []).forEach((entry) => {
          if (!entry?.nodeId) return;
          updateByNodeId.set(String(entry.nodeId), entry);
        });

        const clearResolutionTag = (option: any = {}) => {
          const next = { ...(option || {}) };
          delete (next as any).__duplicateResolutionSource;
          return next;
        };

        const mergeObjects = (existing: any, incoming: any) => {
          if (!existing || typeof existing !== 'object' || Array.isArray(existing)) return incoming;
          if (!incoming || typeof incoming !== 'object' || Array.isArray(incoming)) return incoming !== undefined ? incoming : existing;
          const merged = { ...existing };
          Object.entries(incoming).forEach(([key, value]) => {
            const existingValue = merged[key];
            if (
              value &&
              typeof value === 'object' &&
              !Array.isArray(value) &&
              existingValue &&
              typeof existingValue === 'object' &&
              !Array.isArray(existingValue)
            ) {
              merged[key] = { ...existingValue, ...value };
            } else if (value !== undefined) {
              merged[key] = value;
            }
          });
          return merged;
        };

        const mergeIntoExistingOption = (existingOpt: any, incomingOpt: any, markEdited = false) => {
          const normalizedIncoming = normalizeImportedOption(incomingOpt);
          const mergedOption = {
            ...existingOpt,
            ...normalizedIncoming,
            id: existingOpt?.id ?? normalizedIncoming?.id,
            uuid: existingOpt?.uuid ?? normalizedIncoming?.uuid,
            component_id: existingOpt?.component_id ?? normalizedIncoming?.component_id,
            service_id: existingOpt?.service_id ?? normalizedIncoming?.service_id,
            component_name: existingOpt?.component_name ?? normalizedIncoming?.component_name,
            label: existingOpt?.label ?? normalizedIncoming?.label,
            data: mergeObjects(get(existingOpt, 'data', {}), normalizedIncoming?.data),
          };

          if (existingOpt?.id) {
            mergedOption.operation = 'edited';
          } else if (markEdited) {
            mergedOption.operation = 'edited';
          }

          return mergedOption;
        };

        const prevNodesWithUpdates = prevNodesRaw.map((node: any) => {
          const update = updateByNodeId.get(String(node.id));
          if (!update || node.type !== 'assetNode') return node;

          const currentOptions = Array.isArray(get(node, 'data.options', [])) ? get(node, 'data.options', []) : [];
          const currentByName = new Map<string, any>();
          currentOptions.forEach((opt: any) => {
            const key = normalizeComponentName(get(opt, 'component_name', get(opt, 'label', '')));
            if (key) currentByName.set(key, opt);
          });

          // Source of truth for persisted components: backend asset_components payload
          // fetched before opening duplicate popup.
          const backendOptions = get(assetComponents, `${String(node.id)}.components`, []) as any[];
          const backendComponentNames = new Set(
            (Array.isArray(backendOptions) ? backendOptions : [])
              .map((opt: any) => normalizeComponentName(get(opt, 'component_name', get(opt, 'label', ''))))
              .filter(Boolean)
          );
          const backendComponentIds = new Set(
            (Array.isArray(backendOptions) ? backendOptions : [])
              .map((opt: any) => String(get(opt, 'id', '')).trim())
              .filter(Boolean)
          );
          const backendStableComponentIds = new Set(
            (Array.isArray(backendOptions) ? backendOptions : [])
              .map((opt: any) => String(get(opt, 'component_id', '')).trim())
              .filter((cid: string) => Boolean(cid) && !cid.startsWith('-'))
          );

          const isBackendPersistedComponent = (componentName: any, existingOption?: any) => {
            const normalizedName = normalizeComponentName(componentName);

            const optionId = String(get(existingOption, 'id', '')).trim();
            if (optionId && backendComponentIds.has(optionId)) return true;

            const optionComponentId = String(get(existingOption, 'component_id', '')).trim();
            if (optionComponentId && !optionComponentId.startsWith('-') && backendStableComponentIds.has(optionComponentId)) {
              return true;
            }

            return normalizedName ? backendComponentNames.has(normalizedName) : false;
          };

          // Only treat an asset as persisted when it exists in our persisted baselines
          // (initial server load or last confirmed post-save snapshot).
          // Relying on node.operation caused local-only assets to be misclassified as
          // persisted in some flows, which incorrectly marked merged components as 'edited'.
          const isNodePersisted = persistedAssetNodeIds.has(String(node.id));
          const persistedNamesForNode =
            persistedComponentNamesByAsset.get(String(node.id)) || new Set<string>();

          const deriveOptionOperation = (
            source: string,
            componentName: any,
            currentOperation?: string,
            existingOption?: any
          ): string | undefined => {
            // helper: stable component id detection
            const isStableComponentId = (opt: any) => {
              if (!opt) return false;
              const cid = opt.component_id;
              if (cid === undefined || cid === null) return false;
              if (String(cid).trim().startsWith('-')) return false; // synthetic id
              return true;
            };

            // New (unsaved) asset → every component is part of the asset addition.
            if (!isNodePersisted) return 'added';

            const wasPersisted = persistedNamesForNode.has(normalizeComponentName(componentName));
            const hasBackendIdentity = Boolean(existingOption?.id || existingOption?.uuid || isStableComponentId(existingOption));

            if (source === 'existing') {
              // keep existing unchanged
              return currentOperation;
            }

            if (source === 'merged') {
              // Mark edited only when component truly exists in backend.
              return isBackendPersistedComponent(componentName, existingOption) ? 'edited' : 'added';
            }

            if (source === 'imported' && existingOption) {
              // Overwrite on an unsaved local component must remain added.
              return isBackendPersistedComponent(componentName, existingOption) ? 'edited' : 'added';
            }

            // New imported component with no existing persisted identity.
            return 'added';
          };

          const processedOptions = (update.options || [])
            .map((rawOption: any) => {
              const source = String(get(rawOption, '__duplicateResolutionSource', 'imported'));
              const option = clearResolutionTag(rawOption);

              const key = normalizeComponentName(
                get(option, 'component_name', get(option, 'label', ''))
              );

              const existingOpt = key ? currentByName.get(key) : null;
              const componentName = get(option, 'component_name', get(option, 'label', ''));

              // ✅ STEP 1: decide effective source
              let effectiveSource = source;

              if (source === 'imported' && existingOpt) {
                effectiveSource = 'merged'; // ✅ critical fix
              }

              let resolved: any;

              // ✅ STEP 2: resolve option based on source
              if (effectiveSource === 'existing') {
                // ✅ keep existing untouched
                resolved = existingOpt || option;
              } else if (effectiveSource === 'merged') {
                // When merging into an existing option, mark 'edited' so the backend
                // treats this as an update rather than a naive replacement on subsequent imports.
                resolved = existingOpt
                  ? mergeIntoExistingOption(existingOpt, option, true)
                  : normalizeImportedOption(option);
              } else if (effectiveSource === 'imported') {
                resolved = normalizeImportedOption(option);
              } else {
                resolved = normalizeImportedOption(option);
              }

              if (!resolved) return resolved;

              // ✅ STEP 3: assign operation safely
              if (effectiveSource === 'existing') {
                // ✅ do NOT assign operation
                const { operation, ...rest } = resolved || {};
                resolved = rest;
              } else {
                const nextOperation = deriveOptionOperation(
                  effectiveSource,
                  componentName,
                  get(resolved, 'operation'),
                  existingOpt
                );

                if (nextOperation) {
                  resolved = { ...resolved, operation: nextOperation };
                } else if (Object.prototype.hasOwnProperty.call(resolved, 'operation')) {
                  const { operation: _omitOperation, ...rest } = resolved;
                  resolved = rest;
                }
              }

              const hasExistingIdentity =
                Boolean(existingOpt?.id) ||
                Boolean(existingOpt?.uuid) ||
                (existingOpt?.component_id !== undefined &&
                  existingOpt?.component_id !== null &&
                  !String(existingOpt.component_id).startsWith('-'));

              const backendPersisted = isBackendPersistedComponent(componentName, existingOpt);

              if (
                isNodePersisted &&
                (effectiveSource === 'merged' || (effectiveSource === 'imported' && hasExistingIdentity)) &&
                backendPersisted
              ) {
                resolved = {
                  ...resolved,
                  id: existingOpt?.id ?? resolved.id,
                  uuid: existingOpt?.uuid ?? resolved.uuid,
                  component_id: existingOpt?.component_id ?? resolved.component_id,
                  service_id: existingOpt?.service_id ?? resolved.service_id,
                  operation: 'edited',
                };
              }

              return resolved;
            }).filter((opt: any) => Boolean(opt));

          // Collect the component names already covered by the merge resolution
          const processedNames = new Set(
            processedOptions
              .map((opt: any) => normalizeComponentName(get(opt, 'component_name', get(opt, 'label', ''))))
              .filter(Boolean)
          );

          // Preserve existing components NOT touched by the merge resolution.
          // This is a safety-net for when getExistingOptionsForPair could not load
          // all backend components (e.g. the sidebar was never opened for this asset).
          const orphanedOptions = currentOptions.filter((opt: any) => {
            const name = normalizeComponentName(get(opt, 'component_name', get(opt, 'label', '')));
            return name && !processedNames.has(name);
          });

          // Deduplicate by component_name to guard against double entries caused
          // by timing between setConfig and the assetComponents Redux effect.
          const byKey = new Map<string, any>();
          const allOptions = [...processedOptions, ...orphanedOptions];

          const getOptKey = (opt: any) => {
            const cid = get(opt, 'component_id');
            const name = normalizeComponentName(get(opt, 'component_name', get(opt, 'label', '')));
            if (cid !== undefined && cid !== null && String(cid).trim() !== '') return `cid:${cid}`;
            return `name:${name}`;
          };

          const prefer = (a: any, b: any) => {
            // prefer persisted id
            if (a?.id && !b?.id) return a;
            if (b?.id && !a?.id) return b;
            // prefer edited over added
            if (a?.operation === 'edited' && b?.operation !== 'edited') return a;
            if (b?.operation === 'edited' && a?.operation !== 'edited') return b;
            return a; // stable
          };

          allOptions.forEach((opt: any) => {
            const key = getOptKey(opt);
            const existing = byKey.get(key);
            byKey.set(key, existing ? prefer(existing, opt) : opt);
          });

          const nextOptions = Array.from(byKey.values());

          updatedAssetsForStore.push({
            id: String(node.id),
            options: nextOptions,
          });

          // Keep the asset node status consistent with its components so the UI/status
          // reflects the latest state after merge/overwrite (Bug 2). A new asset stays
          // 'added'; a persisted asset becomes 'edited' when any component changed.
          const hasComponentChanges = nextOptions.some((opt: any) => Boolean(get(opt, 'operation')));
          const existingNodeOperation = get(node, 'operation');
          const nextNodeOperation =
            existingNodeOperation === 'added'
              ? 'added'
              : hasComponentChanges
                ? 'edited'
                : existingNodeOperation;

          return {
            ...node,
            ...(nextNodeOperation ? { operation: nextNodeOperation } : {}),
            data: {
              ...node.data,
              ...(update.data || {}),
              options: nextOptions,
            },
          };
        });

        removedAssetNodesToTrack = prevNodesWithUpdates.filter((node: any) => removeSet.has(String(node.id)));

        const prevNodes = prevNodesWithUpdates.filter((n: any) => !removeSet.has(String(n.id)));
        const prevEdges = prevEdgesRaw.filter(
          (e: any) => !removeSet.has(String(e.source)) && !removeSet.has(String(e.target))
        );

        const existingGatewayNode = prevNodes.find(
          (n: Node) => n.type === 'edgeNode' && String(get(n, 'data.gateway_id')) === String(selectedGatewayId)
        );

        const gatewayNodeId = existingGatewayNode?.id ?? `edge-${selectedGatewayId}`;
        const nodesToAdd: any[] = [];
        const edgesToAdd: any[] = [];

        if (!existingGatewayNode) {
          const gatewayData =
            gateways.find((gw: any) => String(gw.gateway_id) === String(selectedGatewayId)) ?? selectedGatewayData;
          const fallbackGatewayData = gatewayData || {
            gateway_id: selectedGatewayId,
            gateway_name: `Gateway ${selectedGatewayId}`,
          };

          nodesToAdd.push({
            id: gatewayNodeId,
            type: 'edgeNode',
            connectedTo: 'cloud',
            data: {
              ...fallbackGatewayData,
              options: [{ id: 'businessRules', label: 'Business Rules' }],
              label: '',
            },
            operation: 'added',
          });
        }

        const cloudEdgeId = `cloud-${gatewayNodeId}`;
        if (!prevEdges.some((e: any) => e.id === cloudEdgeId)) {
          edgesToAdd.push({ id: cloudEdgeId, source: 'cloud', target: gatewayNodeId });
        }

        const usedNodeIds = new Set(prevNodes.map((n: any) => n.id));
        nodesToAdd.forEach((n: any) => usedNodeIds.add(n.id));

        const usedEdgeIdsBackfill = new Set(prevEdges.map((e: any) => e.id));
        prevNodes.forEach((n: any) => {
          if (n.connectedTo) {
            const backfillId = `${n.connectedTo}-${n.id}`;
            if (!usedEdgeIdsBackfill.has(backfillId)) {
              usedEdgeIdsBackfill.add(backfillId);
              edgesToAdd.push({ id: backfillId, source: n.connectedTo, target: n.id });
            }
          }
        });

        const assetNodes = importedAssets.map((asset: any) => {
          const incomingEnabled = Boolean(get(asset, 'data.enabled', true));
          const incomingName = String(get(asset, 'data.name', '')).trim();
          const incomingIp = String(get(asset, 'data.ip', '')).trim();

          let assetId = asset.id || `asset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          while (usedNodeIds.has(assetId)) {
            assetId = `asset-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          }
          usedNodeIds.add(assetId);

          return {
            id: assetId,
            type: 'assetNode',
            connectedTo: gatewayNodeId,
            data: {
              name: incomingName,
              ip: incomingIp,
              enabled: incomingEnabled,
              gateway_id: selectedGatewayId,
              options: (asset.data?.options ?? []).map((opt: any) => normalizeImportedOption(opt)),
            },
            operation: 'added',
          };
        });

        const usedEdgeIds = new Set(prevEdges.map((e: any) => e.id));
        edgesToAdd.forEach((e: any) => usedEdgeIds.add(e.id));

        assetNodes.forEach((assetNode: any) => {
          let assetEdgeId = `${gatewayNodeId}-${assetNode.id}`;
          while (usedEdgeIds.has(assetEdgeId)) {
            assetEdgeId = `${gatewayNodeId}-${assetNode.id}-${Math.random().toString(36).slice(2, 6)}`;
          }
          usedEdgeIds.add(assetEdgeId);
          edgesToAdd.push({ id: assetEdgeId, source: gatewayNodeId, target: assetNode.id });
        });

        addedAssetsForStore = assetNodes.map((node: any) => ({ id: node.id, options: node.data?.options ?? [] }));

        return {
          ...(prev ?? {}),
          nodes: [...prevNodes, ...nodesToAdd, ...assetNodes],
          edges: [...prevEdges, ...edgesToAdd],
        };
      });

      if (removedAssetNodesToTrack.length) {
        importedRemovedNodesRef.current = Array.from(
          new Map(
            [...importedRemovedNodesRef.current, ...removedAssetNodesToTrack].map((node) => [String(node.id), node] as const)
          ).values()
        );
      }

      addedAssetsForStore.forEach((asset) => {
        dispatch(
          factoryManagementActions.getAssetComponentsDataResponse({
            asset_id: asset.id,
            options: asset.options,
          })
        );
      });

      // Sync updated assets to store so new merged components appear in sidebar immediately
      if (updatedAssetsForStore.length > 0) {
        updatedAssetsForStore.forEach((asset) => {
          if (asset?.id && Array.isArray(asset?.options) && asset.options.length > 0) {
            // Filter out any components that don't have component_name/label
            const validOptions = asset.options.filter((opt: any) => {
              const name = get(opt, 'component_name', get(opt, 'label', ''));
              return String(name ?? '').trim() !== '';
            });
            if (validOptions.length > 0) {
              dispatch(
                factoryManagementActions.getAssetComponentsDataResponse({
                  asset_id: asset.id,
                  options: validOptions,
                })
              );
            }
          }
        });
      }

      setImportDuplicateModal((s) => ({ ...s, open: false, candidateAssets: [], duplicatePairs: [] }));
      setImportPreview((s) => ({
        ...s,
        open: false,
        selectedGatewayId: null,
        selectedGatewayData: null,
        assets: [],
        validationRows: [],
        validationErrors: [],
        validationWarnings: [],
      }));
      setImportScanModal({
        open: false,
        assets: [],
        scanAssetIndexes: [],
        selectedGatewayId: null,
        selectedGatewayData: null,
      });
      setImportMessageValidationModal({
        open: false,
        assets: [],
        failedAssetIndexes: [],
        selectedGatewayId: null,
        selectedGatewayData: null,
      });

      if (requestedImportCount === 0) {
        const usedDuplicateResolution = removeExistingAssetNodeIds.length > 0;
        const hasComponentUpdates = updatedAssetsForStore.length > 0;

        Snackbar.success(
          usedDuplicateResolution
            ? 'Import completed. Duplicate strategy kept existing assets; no new assets were added.'
            : hasComponentUpdates
              ? 'Import completed. New components merged into existing assets. Save to persist.'
              : 'Import completed. No assets were found to import.'
        );
      } else if (removeExistingAssetNodeIds.length > 0) {
        Snackbar.success(
          `${requestedImportCount} asset(s) imported and ${removeExistingAssetNodeIds.length} duplicate asset(s) replaced. Save to persist.`
        );
      } else {
        Snackbar.success(`${requestedImportCount} asset(s) added under the selected gateway. Save to persist.`);
      }
    } catch (err: any) {
      Snackbar.error(`Failed to apply import: ${err?.message ?? 'Unknown error'}`);
    }
  };

  const proceedWithDuplicateResolution = async (
    candidateAssets: any[],
    selectedGatewayId: string,
    selectedGatewayData?: any
  ) => {
    setIsPreparingData(true);
    let shouldKeepPreparing = false;

    try {
      const duplicatePairs = await findImportDuplicatePairs(candidateAssets, selectedGatewayId);
      if (duplicatePairs.length > 0) {
        const duplicateAssetIds = Array.from(
          new Set(duplicatePairs.map((p) => String(p.existingNodeId)).filter(Boolean))
        );

        shouldKeepPreparing = true;
        setQueuedImportDuplicateModal({
          strategy: null,
          candidateAssets,
          totalCandidateAssets: candidateAssets.length,
          duplicatePairs,
          selectedGatewayId,
          selectedGatewayData,
        });

        if (duplicateAssetIds.length > 0) {
          setPendingDuplicateAssetIds(duplicateAssetIds);
          setIsWaitingDuplicateBatch(true);
          dispatch(factoryManagementActions.getAssetComponentsDataBatchRequest(duplicateAssetIds));
        } else {
          setIsWaitingDuplicateBatch(false);
        }

        return;
      }

      applyImportedAssetsToConfig(candidateAssets, selectedGatewayId, selectedGatewayData, []);
    } catch (err: any) {
      Snackbar.error(`Failed to prepare import duplicates: ${err?.message ?? 'Unknown error'}`);
    } finally {
      if (!shouldKeepPreparing) {
        setIsPreparingData(false);
      }
    }
  };

  const handleImportSave = async (editedRows?: any[], mode: 'all' | 'modified' | 'skip' = 'all') => {
    if (!importPreview.selectedGatewayId) {
      Snackbar.warning('Gateway ID missing. Please close and try again.');
      return;
    }

    setIsPreparingData(true);

    try {
      const candidateAssets = Array.isArray(editedRows)
        ? applyValidationRowsToAssets(importPreview.assets, editedRows)
        : importPreview.assets;

      const nextValidation = buildImportValidation(candidateAssets, importPreview.selectedGatewayId);
      setImportPreview((s) => ({
        ...s,
        assets: candidateAssets,
        validationRows: nextValidation.validationRows,
        validationErrors: nextValidation.validationErrors,
        validationWarnings: nextValidation.validationWarnings,
      }));

      const duplicateMarkers = [
        'duplicate with existing asset under selected gateway',
        'already exists in selected gateway',
        'asset already exists in gateway',
        'asset already exists in the selected gateway',
        'component already exists',
      ];
      const blockingErrors = (nextValidation.validationErrors || []).filter((message: string) => {
        const lower = String(message || '').toLowerCase();
        return !duplicateMarkers.some((marker) => lower.includes(marker));
      });

      if (blockingErrors.length > 0) {
        const previewErrors = blockingErrors.slice(0, 2).join(' | ');
        Snackbar.warning(
          previewErrors
            ? `Import blocked: resolve validation errors before continuing. ${previewErrors}`
            : 'Import blocked: resolve validation errors before continuing.'
        );
        setIsPreparingData(false);
        return;
      }

      if (mode === 'skip') {
        setImportPreview((s) => ({
          ...s,
          open: false,
          assets: candidateAssets,
        }));

        setImportScanModal({
          open: false,
          assets: [],
          scanAssetIndexes: [],
          selectedGatewayId: null,
          selectedGatewayData: null,
        });

        setImportMessageValidationModal({
          open: true,
          assets: candidateAssets,
          failedAssetIndexes: [],
          selectedGatewayId: importPreview.selectedGatewayId,
          selectedGatewayData: importPreview.selectedGatewayData,
        });
        return;
      }

      if (mode === 'modified') {
        const missingAssetIds = collectMissingModifiedScanAssetIds(
          candidateAssets,
          importPreview.selectedGatewayId
        );

        if (missingAssetIds.length > 0) {
          setQueuedModifiedScanRequest({
            candidateAssets,
            selectedGatewayId: importPreview.selectedGatewayId,
            selectedGatewayData: importPreview.selectedGatewayData,
          });
          setPendingModifiedScanAssetIds(missingAssetIds);
          setIsWaitingModifiedScanBatch(true);
          dispatch(factoryManagementActions.getAssetComponentsDataBatchRequest(missingAssetIds));
          return;
        }
      }

      const modifiedScanPlan =
        mode === 'modified'
          ? deriveModifiedScanPlan(candidateAssets, importPreview.selectedGatewayId)
          : null;

      const assetsForNextStep = modifiedScanPlan?.assets || candidateAssets;
      const scanAssetIndexes =
        mode === 'modified'
          ? modifiedScanPlan?.scanAssetIndexes || []
          : candidateAssets.map((_: any, idx: number) => idx);

      if (mode === 'modified' && scanAssetIndexes.length === 0) {
        Snackbar.info('No assets require scan based on existing scan_result. Opening message validation directly.');
        setImportPreview((s) => ({
          ...s,
          open: false,
          assets: assetsForNextStep,
        }));
        setImportMessageValidationModal({
          open: true,
          assets: assetsForNextStep,
          failedAssetIndexes: [],
          selectedGatewayId: importPreview.selectedGatewayId,
          selectedGatewayData: importPreview.selectedGatewayData,
        });
        return;
      }

      setImportPreview((s) => ({
        ...s,
        open: true,
        assets: assetsForNextStep,
      }));

      setImportScanModal({
        open: true,
        assets: assetsForNextStep,
        scanAssetIndexes,
        selectedGatewayId: importPreview.selectedGatewayId,
        selectedGatewayData: importPreview.selectedGatewayData,
      });
    } catch (err: any) {
      Snackbar.error(`Failed to prepare import validation: ${err?.message ?? 'Unknown error'}`);
    } finally {
      setIsPreparingData(false);
    }
  };

  const handleImportScanContinue = (payload: {
    assets: any[];
    retainedAssetIndexes: number[];
    failedAssetIndexes: number[];
  }) => {
    if (!importScanModal.selectedGatewayId) {
      Snackbar.warning('Gateway ID missing. Please restart import and try again.');
      return;
    }

    const assetsForMessageValidation = Array.isArray(payload?.assets) ? payload.assets : [];
    if (assetsForMessageValidation.length === 0) {
      Snackbar.warning('No successfully scanned assets available to continue.');
      return;
    }

    setImportScanModal((s) => ({ ...s, open: false }));
    setImportPreview((s) => ({ ...s, open: false }));
    setImportMessageValidationModal({
      open: true,
      assets: assetsForMessageValidation,
      failedAssetIndexes: Array.isArray(payload?.failedAssetIndexes) ? payload.failedAssetIndexes : [],
      selectedGatewayId: importScanModal.selectedGatewayId,
      selectedGatewayData: importScanModal.selectedGatewayData,
    });
  };

  const handleImportMessageValidationBack = () => {
    setImportMessageValidationModal((s) => ({ ...s, open: false }));
    setImportScanModal((s) => ({
      ...s,
      open: true,
      assets: importMessageValidationModal.assets,
      selectedGatewayId: importMessageValidationModal.selectedGatewayId,
      selectedGatewayData: importMessageValidationModal.selectedGatewayData,
    }));
  };

  const handleImportMessageValidationContinue = async (nextAssets: any[]) => {
    if (!importMessageValidationModal.selectedGatewayId) {
      Snackbar.warning('Gateway ID missing. Please restart import and try again.');
      return;
    }

    setImportMessageValidationModal((s) => ({ ...s, open: false }));
    await proceedWithDuplicateResolution(
      nextAssets,
      importMessageValidationModal.selectedGatewayId,
      importMessageValidationModal.selectedGatewayData
    );
  };

  const handleImportDuplicateContinue = (rowStrategies: Record<string, 'overwrite' | 'skip' | 'merge'> = {}) => {
    if (!importDuplicateModal.selectedGatewayId) {
      Snackbar.warning('Selected gateway is missing. Please restart import and try again.');
      setImportDuplicateModal((s) => ({ ...s, open: false }));
      return;
    }

    const { resolvedAssets, removeExistingAssetNodeIds, updateExistingAssets } = buildAssetsFromDuplicateStrategy(
      importDuplicateModal.strategy,
      importDuplicateModal.candidateAssets,
      importDuplicateModal.duplicatePairs,
      rowStrategies
    );

    applyImportedAssetsToConfig(
      resolvedAssets,
      importDuplicateModal.selectedGatewayId,
      importDuplicateModal.selectedGatewayData,
      removeExistingAssetNodeIds,
      updateExistingAssets
    );
  };

  const handleImportConfirm = async () => {
    if (!pendingImportFile) {
      Snackbar.warning('Please choose an import file before continuing.');
      return;
    }

    if (!importGatewayModal.selectedGatewayId) {
      Snackbar.warning('Please select a gateway before importing assets.');
      return;
    }

    setIsImporting(true);
    setIsValidating(true);
    setIsPreparingData(true);
    try {
      const buffer = await pendingImportFile.arrayBuffer();
      const importResult = await parseExcelImport(buffer, pendingImportFile.name, { components });

      const { assets, errors } = importResult;
      if (!Array.isArray(assets) || assets.length === 0) {
        Snackbar.warning('No valid assets were found in the selected file.');
        setImportGatewayModal({ open: false, selectedGatewayId: null, locked: false });
        setPendingImportFile(null);
        return;
      }

      const validation = buildImportValidation(assets, importGatewayModal.selectedGatewayId);
      const selectedGatewayData =
        gateways.find((gw: any) => String(gw.gateway_id) === String(importGatewayModal.selectedGatewayId)) ??
        provisionedGateways.find((gw: any) => String(gw.gateway_id) === String(importGatewayModal.selectedGatewayId)) ??
        null;

      setImportScanModal({
        open: false,
        assets: [],
        scanAssetIndexes: [],
        selectedGatewayId: null,
        selectedGatewayData: null,
      });
      setImportMessageValidationModal({
        open: false,
        assets: [],
        failedAssetIndexes: [],
        selectedGatewayId: null,
        selectedGatewayData: null,
      });

      setImportPreview({
        open: true,
        json: JSON.stringify(assets, null, 2),
        assets,
        errors,
        selectedGatewayId: importGatewayModal.selectedGatewayId,
        selectedGatewayData,
        validationRows: validation.validationRows,
        validationErrors: validation.validationErrors,
        validationWarnings: validation.validationWarnings,
      });


      if (Array.isArray(errors) && errors.length > 0) {
        Snackbar.warning(`Imported with ${errors.length} parser warning(s). Please review before proceeding.`);
      }

      setImportGatewayModal({ open: false, selectedGatewayId: null, locked: false });
      setPendingImportFile(null);
    } catch (err: any) {
      Snackbar.error(`Failed to parse Excel file: ${err?.message ?? 'Unknown error'}`);
    } finally {
      setIsImporting(false);
      setIsValidating(false);
      setIsPreparingData(false);
    }
  };

  const componentOptionsMemo = useMemo(
    () =>
      Array.from(
        new Set<string>(
          (components || [])
            .map((component: any) => String(get(component, 'component_name', '')).trim())
            .filter((name: string) => Boolean(name))
        )
      ).map((name) => ({ label: name, value: name })),
    [components]
  );

  const componentSecretFieldsMapMemo = useMemo(() => Object.fromEntries(getComponentSecretFieldsByName()), [components, secretsData]);
  const componentRequiredSecretsMapMemo = useMemo(() => Object.fromEntries(getComponentRequiredSecretsByName()), [components]);

  const renderSuccessPopup = () => {
    return (
      <PopUp
        title='Success'
        open={isSuccessPopupOpen}
        icon={<SuccessIcon style={{ color: palette.success.dark }} />}
        message='Gateway added'
        confirmation
        confirmLabel='OK'
        onConfirm={() => setIsSuccessPopupOpen(false)}
        onClose={() => setIsSuccessPopupOpen(false)}
      />
    );
  };

  const renderAddModal = () => {
    const columns = [
      { field: 'gateway_name', headerName: 'Display Name', flex: 1 },
      // { field: 'location', headerName: 'Location', flex: 1 },
      {
        field: 'gateway_status',
        headerName: 'Status',
        width: 120,
        headerAlign: 'center',
        align: 'right',
        renderCell: (params: any) => {
          return <Chip sx={addModalStyles.chip} label={params.row.gateway_status} color='primary' variant='outlined' />;
        },
      },
      {
        field: false,
        headerName: '',
        width: 100,
        sortable: false,
        renderCell: ({ row }: any) => {
          return (
            <Button
              onClick={() => {
                setFlowData((nodes: any[]) => [
                  ...nodes,
                  {
                    id: `edge-${row.gateway_id}`,
                    type: 'edgeNode',
                    data: {
                      ...row,
                      options: [
                        {
                          id: 'businessRules',
                          label: 'Business Rules',
                        },
                      ],
                      label: '',
                    },
                  },
                ]);
                closeAddModal();
              }}
              variant={'contained'}
              size='small'
            >
              Add
            </Button>
          );
        },
      },
    ];

    return (
      <Modal title='SELECT THE GATEWAY TO ADD' open={isAddModalOpen} handleClose={closeAddModal}>
        <Box sx={addModalStyles.container}>
          {/*<Box sx={addModalStyles.header}>*/}
          {/*  <Typography>Available Gateway</Typography>*/}
          {/*  <Divider />*/}
          {/*</Box>*/}
          <Box sx={addModalStyles.tableWrapper}>
            <DataTable
              rows={gateways.filter((gateway: any) => gateway.data_transfer_status === 'provisioned')}
              columns={columns}
              hideFooter
              pageSizeOptions={[4]}
              autoHeight
              // tableHeight="220px"
              autoPageSize
              hideBorders
              otherProps={{
                getRowId: (row: any) => row.gateway_id,
              }}
            />
          </Box>
          <Box sx={addModalStyles.footer}>
            <Button variant='outlined' onClick={closeAddModal}>
              CANCEL
            </Button>
            {/*<Button variant="contained" onClick={() => setIsSuccessPopupOpen(true)}>*/}
            {/*  SAVE*/}
            {/*</Button>*/}
          </Box>
        </Box>
      </Modal>
    );
  };

  const isDataFetching =
    isFactoryLoading ||
    isUseCaseDataLoading ||
    isGatewayMasterDataLoading ||
    isComponentMasterDataLoading ||
    isUseCasesListLoading ||
    isMachineryManagementDataLoading ||
    isSelectedRowLoading;

  const [config, setConfig] = useState<{ nodes: Node[]; edges: Edge[] }>({ nodes: [], edges: [] });
  const [removedNodes, setRemovedNodes] = useState<Node[]>([]);
  const [removedComponents, setRemovedComponents] = useState<any>({});
  const importedRemovedNodesRef = useRef<Node[]>([]);
  // Tracks the config state after each successful save.
  // selectedRow.ui_config is NOT refreshed by the backend after save (saga only fires updateFactoryResponse),
  // so normalizedSelectedRowUiConfig stays stale. This ref captures the true post-save baseline
  // and is used to correctly identify persisted nodes/components on subsequent imports.
  const lastSavedConfigRef = useRef<{ nodes: any[]; edges: any[] }>({ nodes: [], edges: [] });
  const normalizedSelectedRowUiConfig = useMemo(() => normalizeUiConfig(selectedRow?.ui_config), [selectedRow?.ui_config]);

  useEffect(() => {
    setConfig(normalizedSelectedRowUiConfig);
  }, [selectedRow]);

  useEffect(() => {
    return () => {
      dispatch(factoryManagementActions.resetAssetComponentsData());
    }
  }, [])

  // NEW: track waiting for canonical server refresh after save
  const [waitingForFactoryRefresh, setWaitingForFactoryRefresh] = useState(false);

  useEffect(() => {
    if (!isUpdateFactorySuccess) return;

    // Clear local removed state immediately for UI responsiveness.
    setRemovedComponents({});
    setRemovedNodes([]);
    importedRemovedNodesRef.current = [];

    // Locally clear operation fields so UI shows the saved state. We'll also ask
    // the backend for fresh factory data and capture the canonical persisted ids
    // into lastSavedConfigRef once it's available.
    setConfig((prev: any) => {
      if (!prev?.nodes) return prev;
      const clearedNodes = (prev.nodes as any[]).map((node: any) => {
        const { operation: _nodeOp, ...nodeWithoutOp } = node;
        if (node.type === 'assetNode') {
          return {
            ...nodeWithoutOp,
            data: {
              ...node.data,
              options: (node.data?.options || []).map((opt: any) => {
                const { operation: _optOp, ...optRest } = opt;
                return optRest;
              }),
            },
          };
        }
        return nodeWithoutOp;
      });
      return { ...prev, nodes: clearedNodes };
    });

    // Ask the store/saga to fetch the fresh factory data so we can capture backend-assigned ids.
    if (rowId) {
      dispatch(factoryManagementActions.getFactoryData(rowId));
      setWaitingForFactoryRefresh(true);
    } else {
      // fallback: if rowId missing, mark lastSavedConfigRef from current config
      lastSavedConfigRef.current = normalizeUiConfig(config);
      setWaitingForFactoryRefresh(false);
    }
  }, [isUpdateFactorySuccess]);

  // when selectedRow updates as a result of the fetch we triggered, capture the canonical UI config.
  useEffect(() => {
    if (!waitingForFactoryRefresh) return;
    try {
      const canonical = normalizeUiConfig(selectedRow?.ui_config);
      lastSavedConfigRef.current = canonical;
    } catch (e) {
      lastSavedConfigRef.current = normalizeUiConfig(config);
    } finally {
      setWaitingForFactoryRefresh(false);
    }
  }, [selectedRow?.ui_config, waitingForFactoryRefresh]);

  const [activeAssets, setActiveAssets] = useState<any>({});

  const getEffectiveSaveNodes = useCallback(() => {
    return getLocallyEffectiveNodes(config.nodes || []);
  }, [config.nodes, removedNodes]);

  const updateLandscape = () => {
    const effectiveNodes = getEffectiveSaveNodes();
    const _assets: any = effectiveNodes.filter((item: any) => item.type === 'assetNode');
    if (_assets.length) {
      const hasEmptyValue = _assets.find((item: any) => {
        if (item.data.enabled) {
          if (has(item.data, 'name') && has(item.data, 'ip')) {
            if (item.data.name.trim() === '' || item.data.ip.trim() === '') {
              return item;
            }
          } else {
            return item;
          }
        }
      });

      if (hasEmptyValue) {
        setEmptyAssetsPopup(true);
      } else {
        const seenIdentityByGateway = new Set<string>();
        const hasDuplicates = _assets.some((asset: any) => {
          const gatewayKey = String(get(asset, 'connectedTo', get(asset, 'data.connectedTo', '')) ?? '');
          const assetName = String(get(asset, 'data.name', ''));
          const assetIp = String(get(asset, 'data.ip', ''));

          if (assetName.trim() === '' && assetIp.trim() === '') return false;

          const nameIdentityKey = `${gatewayKey}::name::${assetName}`;
          const ipIdentityKey = `${gatewayKey}::ip::${assetIp}`;

          if (assetName && seenIdentityByGateway.has(nameIdentityKey)) return true;
          if (assetIp && seenIdentityByGateway.has(ipIdentityKey)) return true;

          if (assetName) seenIdentityByGateway.add(nameIdentityKey);
          if (assetIp) seenIdentityByGateway.add(ipIdentityKey);
          return false;
        });

        if (hasDuplicates) {
          setIsConfirmPopupOpen(true);
        } else {
          updateLandscapeConfirmed();
        }
      }
    } else {
      updateLandscapeConfirmed();
    }
  };

  const updateLandscapeConfirmed = () => {
    const normalizedConfig = normalizeUiConfig(config);
    const effectiveNodes = getEffectiveSaveNodes();

    const persistedNodeOrder = new Map<string, number>();
    (normalizedSelectedRowUiConfig.nodes || []).forEach((existingNode: any, index: number) => {
      persistedNodeOrder.set(String(existingNode?.id), index);
    });

    const currentNodeOrder = new Map<string, number>();
    effectiveNodes.forEach((node: Node, index: number) => {
      currentNodeOrder.set(String(node.id), index);
    });

    const nodes = [...effectiveNodes].sort((a: Node, b: Node) => {
      const aId = String(a.id);
      const bId = String(b.id);
      const aPersistedIndex = persistedNodeOrder.get(aId);
      const bPersistedIndex = persistedNodeOrder.get(bId);

      if (aPersistedIndex !== undefined && bPersistedIndex !== undefined) {
        return aPersistedIndex - bPersistedIndex;
      }
      if (aPersistedIndex !== undefined) return -1;
      if (bPersistedIndex !== undefined) return 1;

      return (currentNodeOrder.get(aId) ?? 0) - (currentNodeOrder.get(bId) ?? 0);
    });

    const nodeIds = new Set(nodes.map((node: Node) => String(node.id)));
    const edges = (normalizedConfig.edges || []).filter((edge: Edge) => {
      const sourceId = String((edge as any).source ?? '');
      const targetId = String((edge as any).target ?? '');
      const sourceValid = sourceId === 'cloud' || nodeIds.has(sourceId);
      const targetValid = targetId === 'cloud' || nodeIds.has(targetId);
      return sourceValid && targetValid;
    });
    const gateways = nodes.filter((node: Node) => node.type === 'edgeNode');
    const gatewayNodeIdSet = new Set(gateways.map((gateway: Node) => String(gateway.id ?? '')));
    const gatewayNodeIdsByGatewayId = new Map<string, string[]>();
    const gatewayDataIdByNodeId = new Map<string, string>();

    gateways.forEach((gateway: Node) => {
      const gatewayNodeId = String(gateway.id ?? '');
      const gatewayDataId = String(get(gateway, 'data.gateway_id', '') ?? '').trim();
      if (!gatewayDataId) return;

      gatewayDataIdByNodeId.set(gatewayNodeId, gatewayDataId);

      const existing = gatewayNodeIdsByGatewayId.get(gatewayDataId) || [];
      gatewayNodeIdsByGatewayId.set(gatewayDataId, Array.from(new Set([...existing, gatewayNodeId])));
    });

    const resolveAssetGatewayDataIds = (asset: NodeItem): Set<string> => {
      const matchedGatewayDataIds = new Set<string>();
      const assetNodeId = String(asset.id ?? '');
      const assetConnectedTo = String(get(asset, 'connectedTo', get(asset, 'data.connectedTo', '')) ?? '').trim();
      const assetGatewayId = String(get(asset, 'data.gateway_id', '') ?? '').trim();

      if (assetConnectedTo) {
        if (gatewayNodeIdSet.has(assetConnectedTo)) {
          const dataId = gatewayDataIdByNodeId.get(assetConnectedTo);
          if (dataId) matchedGatewayDataIds.add(dataId);
        }

        if (gatewayNodeIdsByGatewayId.has(assetConnectedTo)) {
          matchedGatewayDataIds.add(assetConnectedTo);
        }
      }

      if (assetGatewayId) {
        if (gatewayNodeIdsByGatewayId.has(assetGatewayId)) {
          matchedGatewayDataIds.add(assetGatewayId);
        }
      }

      edges.forEach((edge: any) => {
        const sourceId = String(edge?.source ?? '');
        const targetId = String(edge?.target ?? '');
        if (targetId === assetNodeId && gatewayNodeIdSet.has(sourceId)) {
          const dataId = gatewayDataIdByNodeId.get(sourceId);
          if (dataId) matchedGatewayDataIds.add(dataId);
        }

        if (sourceId === assetNodeId && gatewayNodeIdSet.has(targetId)) {
          const dataId = gatewayDataIdByNodeId.get(targetId);
          if (dataId) matchedGatewayDataIds.add(dataId);
        }
      });

      return matchedGatewayDataIds;
    };

    const isAssetUnderGateway = (gateway: Node, asset: NodeItem) => {
      const gatewayDataId = String(get(gateway, 'data.gateway_id', '') ?? '').trim();
      if (!gatewayDataId) return false;
      return resolveAssetGatewayDataIds(asset).has(gatewayDataId);
    };
    let component_config: {
      shop_floor_id: string;
      namespace: string;
      gateways: { id: string; gateway_id: string; components: Record<string, any>[] }[];
    } = {
      shop_floor_id: rowId ?? '',
      namespace: paramCase(selectedRow?.factory_name?.toLowerCase() ?? ''),
      gateways: [],
    };
    // Build a lookup map from previous component_config for fallback when options are empty
    const prevComponentsByAsset = new Map<string, any[]>();
    (selectedRow?.config?.gateways || []).forEach((prevGateway: any) => {
      (prevGateway?.components || []).forEach((comp: any) => {
        const assetId = comp.asset_id;
        if (assetId) {
          if (!prevComponentsByAsset.has(assetId)) {
            prevComponentsByAsset.set(assetId, []);
          }
          prevComponentsByAsset.get(assetId)!.push(comp);
        }
      });
    });
    // Keep payloads clean: empty secret_* fields should be omitted entirely so save requests
    // do not send placeholder secret keys when the user has not selected a secret.
    const stripEmptySecretFields = (value: any) => {
      if (!value || typeof value !== 'object') return value;

      const next = { ...value };
      Object.keys(next).forEach((key) => {
        if (!/^secret_/i.test(String(key))) return;
        const current = next[key];
        if (current === undefined || current === null || String(current).trim() === '') {
          delete next[key];
        }
      });

      return next;
    };

    for (let gateway of gateways) {
      const assets = (nodes as unknown[] as NodeItem[]).filter(
        (node: NodeItem) => node.type === 'assetNode' && isAssetUnderGateway(gateway as Node, node)
      ) as unknown[] as Node[]; //getOutgoers(gateway, nodes, edges);
      const _gateway: { id: string; gateway_id: string; assets: number; components: Record<string, any>[] } = {
        id: gateway.id,
        gateway_id: gateway.data.gateway_id,
        assets: assets.length ?? 0,
        components: [],
      };
      for (let asset of assets.filter((asset: any) => !!asset?.data?.enabled)) {
        const servers: Record<string, any>[] = asset.data?.options ?? [];

        // If no options in current state, try to restore from previous component_config
        if (servers.length === 0 && prevComponentsByAsset.has(String(asset.id))) {
          const prevComps = prevComponentsByAsset.get(String(asset.id)) || [];
          prevComps.forEach((comp: any) => {
            if (comp.enabled) {
              _gateway.components.push(comp);
            }
          });
        } else {
          for (let server of servers) {
            let data = { ...server.data };
            // Sanitize component_config payload before dispatch. This preserves existing behavior
            // for all other fields while dropping only blank secret_* entries.
            data = stripEmptySecretFields(data);
            const service = services.find((service: any) => service.service_id === server.service_id);
            if (service)
              _gateway.components.push({
                floor_id: rowId,
                ...server,
                data: { ...data },
                asset_id: asset.id,
                name: asset.data.name,
                ip: asset.data.ip,
                service,
              });
          }
        }
      }

      // Deduplicate components by backend identity if available, otherwise by asset+component_name.
      // This prevents duplicate entries from repeated imports when a persisted component exists
      // alongside a temporary imported copy with a local UUID.
      const dedupMap = new Map<string, any>();
      _gateway.components.forEach((comp: any) => {
        const assetKey = String(comp?.asset_id ?? '');
        const nameKey = String(get(comp, 'component_name', get(comp, 'label', ''))).trim().toLowerCase();
        const hasStableComponentId =
          comp?.component_id !== undefined &&
          comp?.component_id !== null &&
          String(comp.component_id).trim() !== '' &&
          !String(comp.component_id).startsWith('-');
        const key = hasStableComponentId
          ? `${assetKey}|cid|${String(comp.component_id)}`
          : `asset:${assetKey}:name:${nameKey}`;

        const existing = dedupMap.get(key);
        if (!existing) {
          dedupMap.set(key, comp);
          return;
        }

        // Prefer preserving backend identity and edited operations when choosing which
        // component to keep in case of duplicates.
        const prefer = (a: any, b: any) => {
          if (a?.id && !b?.id) return a;
          if (b?.id && !a?.id) return b;
          if (a?.operation === 'edited' && b?.operation !== 'edited') return a;
          if (b?.operation === 'edited' && a?.operation !== 'edited') return b;
          return a;
        };

        dedupMap.set(key, prefer(existing, comp));
      });

      _gateway.components = Array.from(dedupMap.values());

      component_config.gateways.push(_gateway);
    }

    const persistedNodeIds = new Set([
      // Original loaded config
      ...(normalizedSelectedRowUiConfig.nodes || []).map((existingNode: any) => String(existingNode?.id)),
      // Nodes saved in the current session (handles import→save→save again without selectedRow refresh)
      ...(lastSavedConfigRef.current.nodes || []).map((existingNode: any) => String(existingNode?.id)),
    ]);

    const withDerivedAddedOperation = (nodePayload: any) => {
      if (!nodePayload || nodePayload.type === 'cloudNode') return nodePayload;
      if (nodePayload.operation) return nodePayload;

      return persistedNodeIds.has(String(nodePayload.id))
        ? nodePayload
        : { ...nodePayload, operation: 'added' };
    };
    // ui_config.diff carries option snapshots separately from component_config, so apply the
    // same cleanup here to avoid empty secret keys reappearing in the diff payload path.
    const sanitizeOptionForDiffPayload = (option: any) => {
      const cleanedOption = stripEmptySecretFields({ ...option });
      if (cleanedOption?.data && typeof cleanedOption.data === 'object') {
        cleanedOption.data = stripEmptySecretFields(cleanedOption.data);
      }
      return cleanedOption;
    };

    const uiConfigNodes = nodes.map((node: Node) => {
      if (node.type === 'assetNode') {
        const assetId = node.id;
        const nodePayload = getNodePayload(node, nodes);
        if (removedComponents[assetId]) {
          const optionChanges = [
            ...nodePayload.data.data.options.filter((option: any) => option.operation),
            ...removedComponents[assetId],
          ];

          return withDerivedAddedOperation({
            ...nodePayload,
            data: {
              ...nodePayload.data,
              data: {
                ...nodePayload.data.data,
                options: [
                  ...nodePayload.data.data.options.filter((option: any) => option.operation),
                  ...removedComponents[assetId].map((removedComponent: any) => {
                    const rc = (assetComponents[assetId].components || []).find(
                      (component: any) => component.id === removedComponent.id
                    );
                    return {
                      ...rc,
                      operation: 'deleted',
                    };
                  }),
                ].map((option: any) => ({
                  id: option.id,
                  operation: option.operation,
                  data: {
                    ...sanitizeOptionForDiffPayload(option),
                  },
                })),
              },
            },
            ...(optionChanges.length > 0 ? { operation: nodePayload.operation || 'edited' } : {}),
          });
        } else {
          const hasOptionChanges = nodePayload.data.data.options.some((option: any) => Boolean(option.operation));
          return withDerivedAddedOperation({
            ...nodePayload,
            data: {
              ...nodePayload.data,
              data: {
                ...nodePayload.data.data,
                options: nodePayload.data.data.options
                  .filter((option: any) => option.operation)
                  .map((option: any) => ({
                    id: option.id,
                    operation: option.operation,
                    data: {
                      ...sanitizeOptionForDiffPayload(option),
                    },
                  })),
              },
            },
            ...(hasOptionChanges ? { operation: nodePayload.operation || 'edited' } : {}),
          });
        }
      }
      return withDerivedAddedOperation(getNodePayload(node, nodes));
    });

    const secretsByGateway = new Map<string, Map<string, { component_id: any; secrets: Set<number> }>>();

    const ensureGatewaySecretsMap = (edgeId: any) => {
      const edgeKey = String(edgeId ?? '');
      if (!secretsByGateway.has(edgeKey)) {
        secretsByGateway.set(edgeKey, new Map<string, { component_id: any; secrets: Set<number> }>());
      }
      return secretsByGateway.get(edgeKey)!;
    };

    // 1) Baseline from GET API response (selectedRow.secrets_config)
    (Array.isArray(selectedRow?.secrets_config) ? selectedRow.secrets_config : []).forEach((gateway: any) => {
      const edgeId = get(gateway, 'edge_id');
      const gatewayMap = ensureGatewaySecretsMap(edgeId);

      (Array.isArray(gateway?.components) ? gateway.components : []).forEach((component: any) => {
        const resolvedComponentId = get(component, 'component_id');
        if (resolvedComponentId === undefined || resolvedComponentId === null || String(resolvedComponentId).trim() === '') {
          return;
        }

        const nextSecrets = new Set<number>(
          (Array.isArray(component?.secrets) ? component.secrets : [])
            .map((secretId: any) => Number(secretId))
            .filter(Number.isFinite)
        );

        gatewayMap.set(String(resolvedComponentId), {
          component_id: resolvedComponentId,
          secrets: nextSecrets,
        });
      });
    });

    // 2) Apply only edited component deltas from current local config
    component_config.gateways.forEach(({ gateway_id: edge_id, components }: any) => {
      const gatewayMap = ensureGatewaySecretsMap(edge_id);

      (Array.isArray(components) ? components : []).forEach((component: any) => {
        const { component_id, id, data, operation } = component || {};
        if (!operation) return;

        // Keep existing identifier behavior, with safe fallback.
        const resolvedComponentId = id ?? component_id;
        if (resolvedComponentId === undefined || resolvedComponentId === null || String(resolvedComponentId).trim() === '') {
          return;
        }

        const currentSecrets = Object.values(data || {})
          .filter((value): value is string => typeof value === 'string' && value.startsWith('secret:'))
          .map((secret) => Number(secret.split(':')[1]))
          .filter(Number.isFinite);

        const componentKey = String(resolvedComponentId);

        // If user removed all secrets from this edited component, remove that component entry.
        if (currentSecrets.length === 0) {
          gatewayMap.delete(componentKey);
          return;
        }

        gatewayMap.set(componentKey, {
          component_id: resolvedComponentId,
          secrets: new Set<number>(currentSecrets),
        });
      });
    });

    // 3) Final merged payload (keeps unchanged gateways/components from baseline)
    const secretsConfig = Array.from(secretsByGateway.entries()).map(([edgeKey, componentsMap]) => {
      const numericEdge = Number(edgeKey);
      const edge_id = Number.isFinite(numericEdge) && String(numericEdge) === edgeKey ? numericEdge : edgeKey;

      return {
        edge_id,
        components: Array.from(componentsMap.values()).map(({ component_id, secrets }) => ({
          component_id,
          secrets: Array.from(secrets).sort((a, b) => a - b),
        })),
      };
    });

    const rmNodes = [
      ...removedNodes.map((node: Node) => {
        return getRemovedNodePayload({ ...node, operation: 'deleted' }, normalizedSelectedRowUiConfig.nodes || []);
      }),
      ...importedRemovedNodesRef.current.map((node: Node) => {
        return getRemovedNodePayload({ ...node, operation: 'deleted' }, normalizedSelectedRowUiConfig.nodes || []);
      }),
    ];

    const categorizedNodes = Object.entries([...uiConfigNodes, ...rmNodes].reduce(
      (acc: Record<string, any[]>, node: any) => {
        // acc[node.type] = acc[node.type] || [];
        if (node.operation === 'added' || node.operation === 'edited' || node.operation === 'deleted') {
          if (acc[node.type]) {
            acc[node.type].push(node);
          } else {
            acc[node.type] = [node];
          }
        }
        return acc;
      },
      {}
    )).map(([nodeType, nodes]) => ({
      type: nodeType,
      [`${nodeType}s`]: nodes
    }));

    // Build the payload object so we can reconcile persisted component ids before dispatch
    const dataToSend: any = {
      ...selectedRow,
      id: selectedRow.factory_id,
      ui_config: {
        ...normalizedConfig,
        diff: categorizedNodes,
        nodes,
        edges,
      },
      config: component_config,
      secrets_config: secretsConfig,
      no_of_egs: nodes?.filter((node: Node) => node.type === 'edgeNode')?.length ?? 0,
      no_of_assets: nodes?.filter((node: Node) => node.type === 'assetNode')?.length ?? 0,
      no_of_machines: nodes?.filter((node: Node) => node.type === 'machineNode')?.length ?? 0,
    };

    // Reconcile persisted factory component ids so merged components use existing primary keys
    try {
      const persistedByKey = new Map<string, any>();
      const register = (comp: any) => {
        if (!comp || !comp.asset_id) return;
        const asset = String(comp.asset_id);
        const cid = comp.component_id;
        const uuid = comp.uuid;
        const name = getNormalizedComponentName(comp);
        if (comp.id) persistedByKey.set(`${asset}|id|${comp.id}`, comp);
        if (cid !== undefined && cid !== null) persistedByKey.set(`${asset}|cid|${String(cid)}`, comp);
        if (uuid) persistedByKey.set(`${asset}|uuid|${String(uuid)}`, comp);
        if (name) persistedByKey.set(`${asset}|name|${name}`, comp);
        // service-based fallback key for more robust matching
        const svc = String(comp.service_id ?? '').trim();
        if (svc && name) persistedByKey.set(`${asset}|svc|${svc}|name|${name}`, comp);
      };

      // From previously saved component_config (server source)
      (selectedRow?.config?.gateways || []).forEach((g: any) => {
        (g.components || []).forEach((c: any) => register(c));
      });

      // From normalized UI config (may contain persisted option ids)
      (normalizedSelectedRowUiConfig.nodes || []).forEach((node: any) => {
        if (node?.type !== 'assetNode') return;
        const assetId = String(node.id ?? '');
        const opts = get(node, 'data.options', []) || [];
        (Array.isArray(opts) ? opts : []).forEach((opt: any) => {
          const candidate = {
            id: get(opt, 'id'),
            component_id: get(opt, 'component_id'),
            uuid: get(opt, 'uuid'),
            component_name: get(opt, 'component_name', get(opt, 'label', '')),
            asset_id: assetId,
          };
          register(candidate);
        });
      });

      // From lastSavedConfigRef (post-save baseline)
      (lastSavedConfigRef.current?.nodes || []).forEach((node: any) => {
        if (node?.type !== 'assetNode') return;
        const assetId = String(node.id ?? '');
        const opts = get(node, 'data.options', []) || [];
        (Array.isArray(opts) ? opts : []).forEach((opt: any) => {
          const candidate = {
            id: get(opt, 'id'),
            component_id: get(opt, 'component_id'),
            uuid: get(opt, 'uuid'),
            component_name: get(opt, 'component_name', get(opt, 'label', '')),
            asset_id: assetId,
          };
          register(candidate);
        });
      });

      // Reconcile each component entry in the outgoing component_config.
      // Do not skip reconciliation for components that already have a local import UUID.
      (dataToSend.config?.gateways || []).forEach((gw: any) => {
        (gw.components || []).forEach((comp: any) => {
          const asset = String(comp.asset_id ?? '');
          const tryKeys = [
            comp.component_id !== undefined && comp.component_id !== null ? `${asset}|cid|${String(comp.component_id)}` : null,
            comp.uuid ? `${asset}|uuid|${String(comp.uuid)}` : null,
            comp.component_name ? `${asset}|name|${getNormalizedComponentName(comp)}` : null,
            // service+name key fallback
            comp.service_id ? `${asset}|svc|${String(comp.service_id)}|name|${getNormalizedComponentName(comp)}` : null,
          ].filter(Boolean) as string[];

          for (const key of tryKeys) {
            const matched = persistedByKey.get(key);
            if (matched && matched.id) {
              const isLocalImportId = comp.operation === 'added' && comp.id && typeof comp.id === 'string';
              if (isLocalImportId || String(comp.id) !== String(matched.id)) {
                comp.id = matched.id;
              }

              // preserve existing operation but ensure persisted components are not sent as 'added'
              comp.operation = comp.operation === 'added' ? 'edited' : comp.operation || 'edited';

              // reconcile persisted component_id as well, even if the current comp has a temporary or wrong value
              if (matched.component_id !== undefined && matched.component_id !== null) {
                comp.component_id = matched.component_id;
              }
              break;
            }
          }
        });
      });
    } catch (e) {
      // Non-fatal: if reconciliation fails, continue and allow backend to validate.
      // eslint-disable-next-line no-console
      console.warn('Component id reconciliation failed', e);
    }


    dispatch(
      factoryManagementActions.updateFactoryRequest({
        data: dataToSend,
        pageName: get(outletData, 'site_factory.entity_name', factoryLabel),
      })
    );
    if (isConfirmPopupOpen) {
      setIsConfirmPopupOpen(false);
    }
  };

  const handleConfirmSuccess = () => {
    updateLandscapeConfirmed();
  };

  const handleConfirmClose = (type: any) => {
    if (type === 'assets') {
      setEmptyAssetsPopup(false);
    } else {
      setIsConfirmPopupOpen(false);
    }
  };

  const [editor, setEditor] = useState({ show: false, machine: -1 });

  useEffect(() => {
    return () => {
      if (isLoaded) {
        // UNSAFE__detachAndUnloadImmediate();
        // UNSAFE__unityInstance?.Quit();
        // unload();
      }
    };
  }, [isLoaded]);

  const toggleEditor = useCallback(
    (machineId: number) => {
      if (editor.show) {
        unload().then(() => setEditor({ show: false, machine: -1 }));
      } else {
        setEditor((editor) => ({ show: true, machine: machineId }));
      }
    },
    [editor, unload]
  );

  const auth = useAuth();

  return (
    <Box sx={{ ...Styles.container, border: `1px solid ${themeData.palette.customBorderColor.main}`, position: 'relative' }}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isPreparingData && !isDataFetching ? 1 : 0,
          visibility: isPreparingData && !isDataFetching ? 'visible' : 'hidden',
          pointerEvents: isPreparingData && !isDataFetching ? 'auto' : 'none',
          transition: 'opacity 220ms ease, visibility 220ms ease',
          backgroundColor: themeMode.isLightBG ? 'rgba(255,255,255,0.48)' : 'rgba(0,0,0,0.30)',
        }}
      >
        <CircularProgress size={28} />
      </Box>
      {isDataFetching ? (
        <Box sx={Styles.spinnerWrapper}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              ...Styles.header,
              borderBottom: `1px solid ${themeData.palette.customBorderColor.main}`,
              backgroundColor: themeMode.isLightBG
                ? lighten(themeData.palette.background.default, 0.2)
                : lighten(themeData.palette.background.default, 0.08),
            }}
          >
            <Box sx={Styles.titleWrapper}>
              <Typography sx={{ color: themeData.palette.text.secondary }} fontWeight={400}>
                {get(getCompoDetails, 'titleTag', '')}:
              </Typography>{' '}
              <Typography sx={{ color: themeData.palette.text.primary }} ml={1}>
                {rowTitle}
              </Typography>
            </Box>
            {!readonly && !useCase && (
              <Stack
                direction={'row'}
                sx={{ alignItems: 'center', gap: 2 }}
              >
                {/(archit|vinayak)/i.test(auth?.user?.profile?.name ?? '') && (
                  <Button variant='contained' onClick={() => toggleEditor(-1)}>
                    {editor.show ? 'Configuration' : 'Twin builder'}
                  </Button>
                )}
                <Button
                  variant='outlined'
                  startIcon={<ExcelIcon />}
                  onClick={() => setImportGatewayModal({ open: true, selectedGatewayId: null, locked: false })}
                >
                  IMPORT ASSETS
                </Button>
                <Button
                  variant='contained'
                  onClick={() => updateLandscape()}
                  disabled={!(hasAccessTo.create && hasAccessTo.update)}
                >
                  <SaveIcon />
                  Save
                </Button>
                <VerticalLineIcon style={{ color: themeData.palette.customBorderColor.main }} />
                <Tooltip title='Discard Changes' placement='top'>
                  <IconButton
                    onClick={() => {
                      const factoryId: any = rowId;
                      dispatch(factoryManagementActions.getFactoryData(factoryId));
                      dispatch(factoryManagementActions.resetAssetComponentsData());
                      setActiveAssets({});
                      setRemovedNodes([]);
                      setRemovedComponents({});
                    }}
                  >
                    <RestoreIcon style={{ color: themeData.palette.custom.light }} />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}
          </Box>

          {editor.show ? (
            <Unity
              matchWebGLToCanvasSize={true}
              devicePixelRatio={2}
              style={{ height: '100%', width: '100%' }}
              unityProvider={unityProvider}
            />
          ) : (
            <Box
              sx={{
                ...Styles.flowWrapper,
                backgroundColor: themeMode.isLightBG
                  ? lighten(themeData.palette.background.default, 0.9)
                  : lighten(themeData.palette.background.default, 0.05),
              }}
            >
              <ReactFlowProvider>
                <Flow
                  selectedRowFlowData={flowData}
                  config={config}
                  setConfig={setConfig}
                  gateways={gateways}
                  setEdgeGateways={setFlowData}
                  components={components}
                  machines={machines}
                  services={services}
                  readonly={readonly} //hasAccessTo
                  useCase={useCase}
                  raw={selectedRow}
                  isSelectedRowLoading={isSelectedRowLoading}
                  hasAccessTo={hasAccessTo}
                  activeAssets={activeAssets}
                  setActiveAssets={setActiveAssets}
                  setRemovedNodes={setRemovedNodes}
                  setRemovedComponents={setRemovedComponents}
                  onGatewayImportClick={(gatewayId: string, gatewayData: any) => {
                    const resolvedGatewayId = resolveGatewayIdForImport(gatewayId, gatewayData);

                    if (!resolvedGatewayId) {
                      Snackbar.warning('Unable to identify selected gateway for import. Please use header Import Assets.');
                      return;
                    }

                    setImportGatewayModal({ open: true, selectedGatewayId: resolvedGatewayId, locked: true });
                  }}
                  onCommandResponse={resolveImportScanCommandResponse}
                />
              </ReactFlowProvider>
            </Box>
          )}
          {/*<Typography fontWeight={400} sx={Styles.footer}>*/}
          {/*  Machines will be listed as per the ontology mapping*/}
          {/*</Typography>*/}
          {isAddModalOpen && renderAddModal()}
          {isSuccessPopupOpen && renderSuccessPopup()}
        </>
      )}

      <FlowImportValidationModal
        open={importPreview.open}
        isLoading={isValidating || isPreparingData}
        selectedGatewayName={
          gateways.find((gw: any) => String(gw.gateway_id) === String(importPreview.selectedGatewayId))
            ?.gateway_name || importPreview.selectedGatewayData?.gateway_name || 'N/A'
        }
        parserWarnings={importPreview.errors}
        validationErrors={importPreview.validationErrors}
        validationRows={importPreview.validationRows}
        componentOptions={componentOptionsMemo}
        componentSecretFieldsMap={componentSecretFieldsMapMemo}
        componentRequiredSecretsMap={componentRequiredSecretsMapMemo}
        secretsData={secretsData}
        canSave={Boolean(importPreview.selectedGatewayId)}
        onSkipScan={(rows: any[]) => handleImportSave(rows, 'skip')}
        onScanModified={(rows: any[]) => handleImportSave(rows, 'modified')}
        onSave={(rows: any[]) => handleImportSave(rows, 'all')}
        onClose={() => {

          setImportPreview((s) => ({
            ...s,
            open: false,
            selectedGatewayId: null,
            selectedGatewayData: null,
            assets: [],
            validationRows: [],
            validationErrors: [],
            validationWarnings: [],
          }))
          setImportScanModal({
            open: false,
            assets: [],
            scanAssetIndexes: [],
            selectedGatewayId: null,
            selectedGatewayData: null,
          });
          setImportMessageValidationModal({
            open: false,
            assets: [],
            failedAssetIndexes: [],
            selectedGatewayId: null,
            selectedGatewayData: null,
          });
          setIsWaitingModifiedScanBatch(false);
          setPendingModifiedScanAssetIds([]);
          setQueuedModifiedScanRequest(null);
          setIsWaitingDuplicateBatch(false);
          setPendingDuplicateAssetIds([]);
          setQueuedImportDuplicateModal(null);
        }
        }
      />
      <FlowImportScanModal
        open={importScanModal.open}
        assets={importScanModal.assets}
        scanAssetIndexes={importScanModal.scanAssetIndexes}
        selectedGatewayId={importScanModal.selectedGatewayId}
        onScanComponent={runImportComponentScan}
        onClose={() => {
          setImportScanModal({
            open: false,
            assets: [],
            scanAssetIndexes: [],
            selectedGatewayId: null,
            selectedGatewayData: null,
          });
          setIsWaitingModifiedScanBatch(false);
          setPendingModifiedScanAssetIds([]);
          setQueuedModifiedScanRequest(null);
        }}
        onContinue={handleImportScanContinue}
      />
      <FlowImportMessageValidationModal
        open={importMessageValidationModal.open}
        selectedGatewayName={
          gateways.find((gw: any) => String(gw.gateway_id) === String(importMessageValidationModal.selectedGatewayId))
            ?.gateway_name || importMessageValidationModal.selectedGatewayData?.gateway_name || 'N/A'
        }
        assets={importMessageValidationModal.assets}
        failedAssetIndexes={importMessageValidationModal.failedAssetIndexes}
        validationRows={importPreview.validationRows}
        secretsData={secretsData}
        componentSecretFieldsMap={componentSecretFieldsMapMemo}
        componentSchemaMap={componentSchemaMapMemo}
        onBack={handleImportMessageValidationBack}
        onClose={() => {
          setImportPreview((s) => ({
            ...s,
            open: false,
            selectedGatewayId: null,
            selectedGatewayData: null,
            assets: [],
            validationRows: [],
            validationErrors: [],
            validationWarnings: [],
          }));
          setImportScanModal({
            open: false,
            assets: [],
            scanAssetIndexes: [],
            selectedGatewayId: null,
            selectedGatewayData: null,
          });
          setImportMessageValidationModal({
            open: false,
            assets: [],
            failedAssetIndexes: [],
            selectedGatewayId: null,
            selectedGatewayData: null,
          });
          setIsWaitingModifiedScanBatch(false);
          setPendingModifiedScanAssetIds([]);
          setQueuedModifiedScanRequest(null);
        }}
        onContinue={handleImportMessageValidationContinue}
      />
      {importDuplicateModal.open && (
        <FlowImportDuplicateModal
          open={importDuplicateModal.open}
          strategy={importDuplicateModal.strategy}
          getExistingOptionsForPair={getExistingOptionsForPair}
          duplicatePairs={importDuplicateModal.duplicatePairs}
          totalCandidateAssets={importDuplicateModal.totalCandidateAssets}
          componentSchemaMap={componentSchemaMapMemo}
          onStrategyChange={(value: any) =>
            setImportDuplicateModal((s) => ({ ...s, strategy: value as 'overwrite' | 'skip' | 'merge' | null }))
          }
          onClose={() => {
            setIsPreparingData(false);
            setIsWaitingModifiedScanBatch(false);
            setPendingModifiedScanAssetIds([]);
            setQueuedModifiedScanRequest(null);
            setIsWaitingDuplicateBatch(false);
            setPendingDuplicateAssetIds([]);
            setQueuedImportDuplicateModal(null);
            setImportDuplicateModal((s) => ({ ...s, open: false }));
          }}
          onContinue={handleImportDuplicateContinue}
        />)}

      <PopUp
        open={isConfirmPopupOpen || emptyAssetsPopup}
        icon={<AlertIcon color={palette.warning.main} />}
        message={
          isConfirmPopupOpen
            ? 'It seems like you are attempting to add assets with the same name or IP. Would you like to proceed?'
            : 'You are trying to add assets without providing their name and IP addresse. Please fill in the required fields.'
        }
        cancel={true}
        confirmation={isConfirmPopupOpen ?? true}
        cancelLabel={isConfirmPopupOpen ? 'No' : 'Close'}
        confirmLabel='Yes'
        onConfirm={handleConfirmSuccess}
        onClose={() => handleConfirmClose(isConfirmPopupOpen ? 'duplicate' : 'assets')}
        onCancel={() => handleConfirmClose(isConfirmPopupOpen ? 'duplicate' : 'assets')}
      />

      {/* Import Assets Modal */}
      <FormModal
        isOpen={importGatewayModal.open}
        title='IMPORT ASSETS'
        handleClose={() => {
          setImportGatewayModal({ open: false, selectedGatewayId: null, locked: false });
          setPendingImportFile(null);
          setIsWaitingModifiedScanBatch(false);
          setPendingModifiedScanAssetIds([]);
          setQueuedModifiedScanRequest(null);
        }}
        customStyles={{ maxWidth: '800px', width: '800px' }}
        hideButtons={true}
      >
        <Box sx={{ width: '100%' }}>
          <ImportAssetsModal
            selectedGatewayId={importGatewayModal.selectedGatewayId ?? ''}
            gatewayOptions={provisionedGateways.map((gw: any) => ({
              value: String(gw.gateway_id),
              label: gw.gateway_name,
            }))}
            onGatewayChange={(gatewayId: string) =>
              setImportGatewayModal((s) => ({ ...s, selectedGatewayId: gatewayId }))
            }
            onFileChange={setPendingImportFile}
            disableGatewaySelect={Boolean(importGatewayModal.locked)}
            fileHintText='(Import Excel)'
            accept='.xlsx,.xls,.csv'
          />

          {/* Button Container */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
            <Button
              variant='outlined'
              sx={{ minWidth: 100 }}
              onClick={() => {
                setImportGatewayModal({ open: false, selectedGatewayId: null, locked: false });
                setPendingImportFile(null);
                setIsWaitingModifiedScanBatch(false);
                setPendingModifiedScanAssetIds([]);
                setQueuedModifiedScanRequest(null);
              }}
            >
              CANCEL
            </Button>
            <Button
              variant='contained'
              sx={{ minWidth: 100 }}
              onClick={handleImportConfirm}
              disabled={isImporting || !importGatewayModal.selectedGatewayId || !pendingImportFile}
            >
              {isImporting ? <CircularProgress size={18} color='inherit' /> : 'IMPORT'}
            </Button>
          </Box>
        </Box>
      </FormModal>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  isUseCaseDataLoading: state.buildUseCase.isUseCaseDataLoading,
  isFactoryLoading: state.factoryManagement.isFactoryLoading,
  isUseCasesListLoading: state.buildUseCase.isUseCasesListLoading,
  isUpdateUseCaseSuccess: state.buildUseCase.isUpdateUseCaseSuccess,
  isGatewayMasterDataLoading: state.gatewayMaster.isGatewayMasterDataLoading,
  isComponentMasterDataLoading: state.componentMaster.isComponentMasterDataLoading,
  isMachineryManagementDataLoading: state.machineryManagement.isMachineryManagementDataLoading,
  gateways: state.gatewayMaster.gatewayMasterData,
  components: state.componentMaster.componentMasterData,
  machines: state.machineryManagement.machineryManagementData,
  services: state.platformServicesMaster.platformServicesMasterData,
  factoriesList: state.factoryManagement.factoriesList,
  userAccess: state.profile.userAccess,
  assetComponents: state.factoryManagement.assetComponentsData,
  isUpdateFactorySuccess: state.factoryManagement.isUpdateFactorySuccess,
  oldNodes: state.factoryManagement.uiConfigNodes,
  secretsData: state.secretsManager.secretsData,
});

export default connect(mapStateToProps)(FlowRenderer);